import React, { Component } from "react";
import PropTypes, { number } from "prop-types";
import { connect } from "react-redux";
import { List, OrderedMap, Map } from "immutable";
import { bindActionCreators } from "redux";
import { Col, Statistic, Icon, Button, List as AntList, Spin, Row, notification, Collapse, Tag, Upload, Modal, Input, InputNumber, message, Card, Divider } from "antd";
import "../../styles/company-scheme-details.css";
import { STATE_STATUS } from "constants";
import {
    fetchCompanyLosSchemes,
    updateCompanyLosSchemes,
    fetchFee,
    fetchFeeMaster,
    fetchAddFee,
    fetchBounceCharges,
    fetchPrePaymentCharges,
    fetchPrePaymentChargesMaster,
    fetchBounceChargesMaster
} from "./actions/index";
import CompanySchemeDetailsForm from "./forms/company-scheme-details-form";
import CompanyFeeForm from "./forms/company-fee-form";
import CompanyService from "./services/company-los-services";
import ConfirmationActionModal from "../../components/confirmation-action-modal";
import moment from "moment";
import AddCommonSchemeDetail from "./add-common-scheme-form";
import { getAuthToken } from "utilities/auth";
import { ADD_COMMON_FORM, fieldsKeys } from "./constants/fields_info_json";
import { GenericToolTip } from "../../components/genericTooltip";
import { CheckActionPermission } from "./checkPermissions";
import AddCashCardForm from "./add-cash-card-form";
import AddCombinationalSchemeDetail from "./add-combination-scheme-form";
import AddSubventionSchemeDetail from "./add-subvention-scheme-form";
import AddTermLoanSchemeDetail from "./add-term-loan-scheme-form";
import CompanyLosService from "./services/company-los-services";
import CompanyBounceChargeForm from "./forms/company-bounce-charge-form";
import CompanyPrePaymentChargeForm from "./forms/company-pre-payment-charge-form";
import _capitalize from "lodash/capitalize";
import { SubventionType } from "../../constants/enums";
import AddCepSchemeForm from "./add-cep-scheme-form";


const FEE_CALCULATION_TYPES = {
    0: "UNDEFINED",
    1: "FIXED",
    2: "PERCENTAGE"
};

const CHARGE_TYPE = new OrderedMap({
    1: "At Account Creation",
    2: "At First Disbursal",
    3: "Manually"
});

const FEE_CALCULATION_LABELS = {
    UNDEFINED: " ",
    FIXED: "₹",
    PERCENTAGE: "%",
};

const FEE_LABELS = {
    UNDEFINED: "",
    ON_BOARDING_FEE: "On-boarding Fee",
    ANNUAL_FEE: "Annual Fee",
    OVERDUE_FEE: "Overdue Fee",
    TXN_PROCESSING_FEE: "Transaction Processing Fee",
    EXCESS_LIMIT_FEE: "Excess Limit Fee",
    PEAK_LIMIT_FEE: "Peak Limit Fee",
    ADHOC_TER_FEE: "Adhoc TER Fee",
    CHEQUE_BOUNCE_CHARGES: "Cheque Bounce Charges",
    NACH_BOUNCE_CHARGES: "Nach Bounce Charges",
    PROCESSING_FEE: "Processing Fee",
    DOCUMENTATION_CHARGES: "Documentation Charges",
    OTHER_CHARGES: "Other Charges"
};

const FEE_TYPES = {
    0: "UNDEFINED",
    1: "ON_BOARDING_FEE",
    2: "ANNUAL_FEE",
    3: "OVERDUE_FEE",
    4: "TXN_PROCESSING_FEE",
    5: "PEAK_LIMIT_FEE",
    6: "ADHOC_TER_FEE",
    7: "EXCESS_LIMIT_FEE",
    8: "CHEQUE_BOUNCE_CHARGES",
    9: "NACH_BOUNCE_CHARGES",
    10: "PROCESSING_FEE",
    11: "DOCUMENTATION_CHARGES",
    12: "OTHER_CHARGES",
};

const InterestType = [
    {
        label: "Flat",
        value: "1"
    },
    {
        label: "Reducing",
        value: "2"
    }
];

const InstalmentDateCalculation = [
    {
        label: "Fixed Date",
        value: "1"
    },
    {
        label: "Basis Disbursal Date",
        value: "2"
    }
];

const { Panel } = Collapse;

class CompanySchemeDetailsDisplay extends Component {

    state = {
        visible: false,
        feeVisibile: false,
        currentId: "",
        loading: false,
        currentFeeId: "",
        schemeMigrating: false,
        confirmationModalShow: false,
        dwSpDefaultEditModal: false,
        dwSpEditModal: false,
        default_disbursal_wait_days: null,
        default_subvention_days: null,
        default_subvention_perc: null,
        disbursal_wait_days: null,
        subvention_days: null,
        subvention_perc: null,
        default_normalRoi: null,
        isFlexible: false,
        addSubventionScheme: false,
        openModalSubventionScheme: false,
        maxNormalRoi: null,
        minNormalRoi: null,
        anchorUnit: null,
        openAddCommoneSchemeBtn: false,
        isDefaultScheme: false,
        isLendingScheme: false,
        partnerbank_data: null,
        schemeId: null,
        showDWDError: false,
        showSPError: false,
        errMsg: null,
        overdueTenor: null,
        showConfirmModal: false,
        confirmLoading: false,
        show_default_disbursal_wait_days: null,
        show_default_subvention_days: null,
        show_default_subvention_perc: null,
        showDefaultConfirm: false,
        editLoading: false,
        show_api_err: false,
        non_field_error: null,
        uploading_id : "",
        swd_readOnly: false,
        openAddCashCard: false,
        openAddCombinationalSchemeBtn: false,
        openAddSubventionSchemeBtn: false,
        openAddTermLoanSchemeBtn: false,
        openVendorFinanceSchemeBtn: false,
        anchorList: [],
        sellerRoi : null,
        bouceChargeVisible: false,
        prePaymentChargeVisible: false,
        openAddCepSchemeBtn: false,
    }

    componentDidMount() {
        this.props.fetchFeeMaster();

        //Fetch addedd Bounce charges and pre payment charges
        this.props.fetchBounceCharges(this.props.companyId);
        this.props.fetchPrePaymentCharges(this.props.companyId);

        //Fetch all Bounce charges and pre payment charges
        this.props.fetchPrePaymentChargesMaster();
        this.props.fetchBounceChargesMaster();

        CompanyLosService.getCompanyLosDetail(this.props.companyId).then(({data}) => {
            this.setState({
                anchorList: data.all_anchors,
            });
        });
        this.props.fetchFee(this.props.companyId);
        if (!this.props.schemeDetailsStatus || this.props.schemeDetailsStatus === STATE_STATUS.UNFETCHED) {
            this.props.fetchCompanyLosSchemes(this.props.companyId);
        }
        CompanyService.getLendingPartners().then(({ data }) => {
            this.setState({
                partnerbank_data: data
            });
        }).catch(() => {
            console.log("error");
        });
    }

    componentDidUpdate() {
        if (this.state.loading && this.props.schemeDetailsStatus === STATE_STATUS.UPDATED) {
            this.setState({
                visible: false,
                currentId: "",
                loading: false
            });
        }
        if (this.state.loading && this.props.schemeDetailsStatus === STATE_STATUS.FETCH_FAILED) {
            this.setState({
                loading: false
            });
        }
        if (this.state.feeLoading && this.props.feeAddEditStatus === STATE_STATUS.FETCHED && this.props.feeFetchStatus === STATE_STATUS.FETCHED) {
            this.setState({
                feeVisibile: false,
                currentFeeId: "",
                feeLoading: false
            });
        }
        if (this.state.loading && this.props.feeAddEditStatus === STATE_STATUS.FETCH_FAILED) {
            this.setState({
                feeLoading: false,
                loading: false
            });
        }
    }


    toggleModal = () => {
        if (this.state.visible) {
            this.setState({
                visible: !this.state.visible,
                currentId: ""
            });
        } else {
            this.setState({
                visible: !this.state.visible
            });
        }
    }

    toggleFeeModal = () => {
        if (this.state.feeVisibile) {
            this.setState({
                feeVisibile: !this.state.feeVisibile,
                currentFeeId: ""
            });
        } else {
            this.setState({
                feeVisibile: !this.state.feeVisibile
            });
        }
    }

    toggleBounceChargeModal = () => {
        this.setState({
            bouceChargeVisible: !this.state.bouceChargeVisible
        });
    }


    togglePrePaymentChargeModal = () => {
        this.setState({
            prePaymentChargeVisible: !this.state.prePaymentChargeVisible
        });
    }



    editScheme = _ => {
        this.setState({
            currentId: _
        }, () => {
            this.toggleModal();
        });
    }

    editFee = _ => {
        this.setState({
            currentFeeId: _
        }, () => {
            this.toggleFeeModal();
        });
    }

    getCharge = (type, charge) => {
        if (type === 1) {
            return FEE_CALCULATION_LABELS[FEE_CALCULATION_TYPES[type]] + charge;
        } else if (type === 2) {
            return charge + FEE_CALCULATION_LABELS[FEE_CALCULATION_TYPES[type]];
        }
        return charge;
    }

    renderFeeListItem = (_, k) => {
        return (
            <AntList.Item
                key={k}
                className={
                    "border-none flex-column padless-card mt-10 schemes-detail bg-white align-items-start"
                }
            >
                <div className={"d-flex p-5 justify-content-space-between w-100"}>
                    <h3 className={"p-5"}>
                        {_.lending_partner?.code} | {FEE_LABELS[FEE_TYPES[_.fee_master.type]]} | {_.fee_master.name} | {CHARGE_TYPE.find((__, k) => k == _.charge_at)} {_.toJS().from_date && _.toJS().to_date ? <span>| From {moment(_.toJS().from_date).format("DD-MMM-YYYY")} to {moment(_.toJS().to_date).format("DD-MMM-YYYY")}</span> : null}
                    </h3>
                    <Icon
                        onClick={() => this.editFee(_.id)}
                        className={"cursor-pointer"}
                        style={{ padding: "10px", fontSize: "20px", background: "#fff", color: "#2D9CDB" }}
                        type={"edit"}
                        theme={"outlined"}
                    />
                </div>
                <div className={"d-flex w-100"}>
                    <div className={"w-100 d-flex flex-column"}>
                        {(_.fee_master && _.fee_master.configuration || []).map((__, key) =>
                            <Row style={{ borderBottom: "0.2px solid rgba(0, 0, 0, 0.4)" }} className={"w-100 m-10 pb-5"} key={key}>
                                <Col span={8}>
                                    <Statistic
                                        valueStyle={{
                                            fontSize: "16px",
                                            fontWeight: 600
                                        }}
                                        title={"From Limit"}
                                        value={__.from_limit}
                                    />
                                </Col>
                                <Col span={8}>
                                    <Statistic
                                        valueStyle={{
                                            fontSize: "16px",
                                            fontWeight: 600
                                        }}
                                        title={"To Limit"}
                                        value={__.to_limit}
                                    />
                                </Col>
                                <Col span={8}>
                                    <Statistic
                                        valueStyle={{
                                            fontSize: "16px",
                                            fontWeight: 600
                                        }}
                                        title={"Charge"}
                                        value={this.getCharge(__.fee_calculation_type, __.value)}
                                    />
                                </Col>
                            </Row>
                        )}
                    </div>
                </div>
            </AntList.Item>
        );
    }

    makeDefault(schemeId){
        this.setState({
            schemeId: schemeId,
            showConfirmModal: true
        });
    }

    onConfirmSubmit(){
        const data = {
            "is_default_scheme": true
        };
        this.setState({
            confirmLoading: true
        });
        CompanyService.makeSchemeDefault(this.props.companyId, this.state.schemeId, data).then(({ resData }) => {
            console.log(resData);
            message.success("Scheme updated!");
            this.setState({
                loading: true,
                confirmLoading: false,
                showConfirmModal:false
            });
            this.props.fetchCompanyLosSchemes(this.props.companyId);
        }).catch(() => {
            this.setState({
                confirmLoading: false
            });
            console.log("error");
        });
    }

    editDefaultSp(isFlexible, item, normalRoi, schemeId, overdueTenor, schemeData , isCombinationScheme = false){
        this.setState({
            isFlexible: isFlexible,
            currentSchemeData: schemeData
        });
        
        if(item){
            if(schemeData.toJS().cashback_sharing_percentage_for_dealer == null && schemeData.toJS().cashback_sharing_percentage_for_seller == null){
                this.setState({
                    show_default_disbursal_wait_days: item.disbursal_wait_days,
                    show_default_subvention_days: item.subvention_days,
                    show_default_subvention_perc: item.subvention_perc,
                    default_disbursal_wait_days: item.disbursal_wait_days,
                    default_subvention_days: item.subvention_days,
                    default_subvention_perc: item.subvention_perc,
                    default_normalRoi: normalRoi,
                    overdueTenor: overdueTenor,
                    dwSpDefaultEditModal: true,
                    swd_readOnly: true,
                    schemeId: schemeId,
                    sellerRoi : isCombinationScheme ? schemeData.get("min_normal_roi") - schemeData.get("min_normal_roi_buyer" , 0) || 0 : null
                });
            }else{
                this.setState({
                    show_default_disbursal_wait_days: item.disbursal_wait_days,
                    show_default_subvention_days: item.subvention_days,
                    show_default_subvention_perc: item.subvention_perc,
                    default_disbursal_wait_days: item.disbursal_wait_days,
                    default_subvention_days: item.subvention_days,
                    default_subvention_perc: item.subvention_perc,
                    default_normalRoi: normalRoi,
                    overdueTenor: overdueTenor,
                    dwSpDefaultEditModal: true,
                    swd_readOnly: false,
                    schemeId: schemeId,
                    sellerRoi : isCombinationScheme ? schemeData.get("min_normal_roi") - schemeData.get("min_normal_roi_buyer" , 0) || 0 : null
                });
            }
            // this.setState({
            //     show_default_disbursal_wait_days: item.disbursal_wait_days,
            //     show_default_subvention_days: item.subvention_days,
            //     show_default_subvention_perc: item.subvention_perc,
            //     default_disbursal_wait_days: item.disbursal_wait_days,
            //     default_subvention_days: item.subvention_days,
            //     default_subvention_perc: item.subvention_perc,
            //     default_normalRoi: normalRoi,
            //     overdueTenor: overdueTenor,
            //     dwSpDefaultEditModal: true,
            //     schemeId: schemeId
            // });
        }
    }

    editSp(isFlexible, normalRoi, schemeId, overdueTenor, schemeData ,isCombinationScheme = false ){
        this.setState({
            isFlexible: isFlexible,
            currentSchemeData: schemeData
        });
        if(schemeData.toJS().cashback_sharing_percentage_for_dealer == null && schemeData.toJS().cashback_sharing_percentage_for_seller == null){
            this.setState({
                disbursal_wait_days: null,
                subvention_days: 0,
                subvention_perc: 0,
                default_normalRoi: normalRoi,
                schemeId: schemeId,
                overdueTenor: overdueTenor,
                dwSpEditModal: true,
                swd_readOnly: true,
                sellerRoi : isCombinationScheme ? schemeData.get("min_normal_roi") - schemeData.get("min_normal_roi_buyer" , 0) || 0 : null
            });
        }else{
            this.setState({
                disbursal_wait_days: null,
                subvention_days: null,
                subvention_perc: null,
                default_normalRoi: normalRoi,
                schemeId: schemeId,
                overdueTenor: overdueTenor,
                dwSpEditModal: true,
                swd_readOnly: false,
                sellerRoi : isCombinationScheme ? schemeData.get("min_normal_roi") - schemeData.get("min_normal_roi_buyer" , 0) || 0 : null
            });
        }
    }

    showRoiToUser = (key , value) => {
        if((key == "Actual Overdue ROI" || key == "Overdue ROI" || key == "Normal ROI") && !this.props.roi_permissions){
            return key
        }else{
            return value;
        }

    }
    renderListItem = (_, key , hideRoi = false) => {
        return (
            <AntList.Item
                key={key}
                className={
                    "border-none flex-column padless-card schemes-detail bg-white"
                }
            >
                <div className={"d-flex flex-row w-100 flex-wrap"}>
                    <Row>
                    {
                        _._is_default_scheme && <Col span={8} style={{padding: "10px"}}>
                            <Tag color="geekblue">Default</Tag>
                        </Col>
                    }
                    {
                        _.anchor.is_anchor_aligned != null && <Col span={8} style={{padding: "10px"}}>
                            <Tag color={_.anchor.is_anchor_aligned ? "geekblue" : "volcano"}>{_.anchor.is_anchor_aligned == true ? "Anchor Aligned" : _.anchor.is_anchor_aligned == false ? "Anchor Not Aligned" : ""}</Tag>
                        </Col>
                    }
                    </Row>
                    {
                        _.lending_partner ? <Col className={"ml-10"} span={8}>
                            <div>
                                <p style={{ margin: "0px" }}>Lending Partner <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("lending_partner")} /></p>
                                <h3>{_.lending_partner.short_name}</h3>
                            </div>
                        </Col>:null
                    }
                    <Col span={24}>
                        <Col span={24}>
                            <CheckActionPermission component={<div className={"d-flex m-5 pt-10 mt-10 mb-10 flex-row justify-content-space-between align-items-center"}>
                                <div className={"flex-row justify-content-space-between"} style={{display: "flex", width: "59%"}}>
                                    <Col span={24}>
                                        <Col span={12}>
                                            <p style={{ margin: "0px", marginLeft: "10px" }}>Scheme ID <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("scheme_id")} /><h3>{_.id}</h3></p>
                                        </Col>
                                        <Col span={12}>
                                            {
                                                _.anchor?.short_name && <p style={{ margin: "0px", marginLeft: "10px" }}>Anchor <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("anchor")} /><h3>{_.anchor?.short_name}</h3></p>
                                            }
                                        </Col>
                                    </Col>
                                </div>
                                {
                                    !_._is_default_scheme && <Col span={6} className={"d-flex flex-row-reverse m-5"} style={{ paddingRight: "16px" }}>
                                        <Button onClick={() => this.makeDefault(_.id)} type="primary">Set As Default {_.anchor?.short_name && " for " + _.anchor?.short_name}</Button>
                                    </Col>
                                }
                            </div>} permission={this.props.schemeActionPermissions} />
                        </Col>
                    </Col>
                    {/* <Col className={"ml-10"} span={24}>
                        <div>
                            <p style={{ margin: "0px" }}>Scheme ID <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("scheme_id")} /></p>
                            <h3>{_.id}</h3>
                        </div>
                    </Col> */}
                    <Col className={"ml-10"} span={24}>
                        {_.newSchemeFirstSection.map((__, k) => (
                            <Col className={"mb-10"} key={k} span={7}>
                                <Statistic
                                    valueStyle={{
                                        fontSize: "16px",
                                        fontWeight: 600
                                    }}
                                    title={<span>{__[0]}  {fieldsKeys(__[0]) ? <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get(fieldsKeys(__[0]))} /> : null}</span>}
                                    value = {this.showRoiToUser(__[0] , __[1])}
                                // suffix={<span style={{fontSize: "12px"}}><Icon type="info" /><span>{__[2]}</span></span>}
                                />
                            </Col>
                        ))}
                    </Col>
                    <Col className={"ml-10 mt-10"} span={24}>
                        <h3>ROI Schedule</h3>
                        {
                            _._roi_schedule_arr.map((__, k) => (
                                <Col className={"mb-10"} key={k} span={24}>
                                    <Col span={6}>
                                        <p>From Days:</p>
                                        <h3>{__.from_days}</h3>
                                    </Col>
                                    <Col span={6}>
                                        <p>To Days:</p>
                                        <h3>{__.to_days}</h3>
                                    </Col>
                                    <Col span={6}>
                                        <p>ROI:</p>
                                        {this.props.roi_permissions ? <h3>{__.roi}</h3> : <h3>{k == 0 ? "Normal ROI" : k + 1 == _._roi_schedule_arr.length ? "Overdue ROI" : "ROI"}</h3>}
                                        {/* {!this.props.roi_permissions && hideRoi ? <h3>{k == 0 && ['18.250%', '18.25'].includes(__.roi.toString()) ? "Normal ROI" : k + 1 == _._roi_schedule_arr.length && ["27.375%", "27.375"].includes(__.roi.toString()) ? "Overdue ROI" : __.roi}</h3>
                                            : <h3>{__.roi}</h3>} */}
                                    </Col>

                                    <Col span={6}>
                                        <p>Adhoc ROI:</p>
                                        {<h3>{this.props.roi_permissions ? __.adhoc_roi : "Adhoc ROI"}</h3>}
                                    </Col>
                                </Col>
                            ))
                        }
                        {
                            _.subvention_by !== "Cashback not applicable"?<React.Fragment>
                                {
                                    _.subvention_by == "Seller" ? <React.Fragment>
                                        {_.newSchemeSecThree.filter((item) => item[0] !== "Progcap Subvention Days").map((__, k) => (
                                            <Col className={"mb-10"} key={k} span={6}>
                                                <Statistic
                                                    valueStyle={{
                                                        fontSize: "16px",
                                                        fontWeight: 600
                                                    }}
                                                    title={<span>{__[0]}  {fieldsKeys(__[0]) ? <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get(fieldsKeys(__[0]))} /> : null}</span>}
                                                    value={__[1]}
                                                />
                                            </Col>
                                        ))}
                                    </React.Fragment>:<React.Fragment>
                                        {_.newSchemeSecThree.filter((item) => item[0] !== "Cashback to Dealer" && item[0] !== "Cashback to Seller" && item[0] !== "Cashback to Progcap").map((__, k) => (
                                            <Col className={"mb-10"} key={k} span={6}>
                                                <Statistic
                                                    valueStyle={{
                                                        fontSize: "16px",
                                                        fontWeight: 600
                                                    }}
                                                    title={<span>{__[0]}  {fieldsKeys(__[0]) ? <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get(fieldsKeys(__[0]))} /> : null}</span>}
                                                    value={__[1]}
                                                />
                                            </Col>
                                        ))}
                                    </React.Fragment>
                                }
                            </React.Fragment>:<React.Fragment>
                                {_.newSchemeSecThree.filter((item) => item[0] == "Stop Billing Days" || item[0] == "Cooling Period").map((__, k) => (
                                    <Col className={"mb-10"} key={k} span={6}>
                                        <Statistic
                                            valueStyle={{
                                                fontSize: "16px",
                                                fontWeight: 600
                                            }}
                                            title={<span>{__[0]}  {fieldsKeys(__[0]) ? <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get(fieldsKeys(__[0]))} /> : null}</span>}
                                            value={__[1]}
                                        />
                                    </Col>
                                ))}
                            </React.Fragment>
                        }
                    </Col>
                    <Col className={"ml-10 mt-10"} span={24}>
                        {this.state.anchorList?.find(el=>el.id === _.anchor?.id && el.is_samsung_program === true) && <Col span={6}>
                            <p>Deviation Allowed: </p>
                            <h3>{_.deviation_allowed == true ? "Yes" : _.deviation_allowed == false ? "No" : "--" }</h3>
                        </Col>}
                        {this.state.anchorList?.find(el=>el.id === _.anchor?.id && el.is_samsung_program === true) && <Col span={6}>
                            <p>Limit Days: </p>
                            <h3>{_.limit_days || "--"}</h3>
                        </Col>}
                    </Col>
                    <Col className={"ml-10 mt-10"} span={24}>
                        <Col span={6}>
                            <p>Disbursal Wait Days: <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("disbursal_wait_days")} /></p>
                            <h3>{_.dwd_sp_default.disbursal_wait_days}</h3>
                        </Col>
                        {
                            // _.subvention_by == "Seller" ?
                             <React.Fragment>
                                <Col span={6}>
                                    <p>Subvention %: <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("subvention_perc")} /></p>
                                    <h3>{_.dwd_sp_default.subvention_perc + "%"}</h3>
                                </Col>
                                <Col span={6}>
                                    <p>Subvention Days: <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("subvention_days")} /></p>
                                    <h3>{_.dwd_sp_default.subvention_days}</h3>
                                </Col>
                            </React.Fragment>
                            // :null
                        }
                        {/* {_.newSchemeEditFirstSec.map((__, k) => (
                            <Col className={"mb-10"} key={k} span={6}>
                                <Statistic
                                    valueStyle={{
                                        fontSize: "16px",
                                        fontWeight: 600
                                    }}
                                    title={__[0]}
                                    value={__[1]}
                                />
                            </Col>
                        ))} */}
                        {_.scheme_type != 11 && <CheckActionPermission
                            component={<Button style={{ marginTop: "10px", color: "#40a9ff", borderColor: "#40a9ff" }} onClick={() => this.editDefaultSp(false, _.dwd_sp_default, _.min_normal_roi, _.id, _.overdue_tenor, _)}>Edit</Button>}
                            permission={this.props.schemeActionPermissions}
                        />}
                    </Col>
                    <Col span={24} style={{ marginTop: "20px" }}>
                        <Collapse  defaultActiveKey={["1"]} >
                            <Panel header="Flexible Parameters:-" key="1">
                                <Col className={"ml-10 mt-10"} span={24}>
                                    {
                                        _.new_dw_sp_all.map((__, k) => (
                                            <Col className={"mb-10"} key={k} span={18}>
                                                <Col span={6}>
                                                    <p>Disbursal Wait days: <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("disbursal_wait_days")} /></p>
                                                    <h3>{__.disbursal_wait_days}</h3>
                                                </Col>
                                                {
                                                    _.subvention_by == "Seller" ? <React.Fragment>
                                                        <Col span={6}>
                                                            <p>Subvention %: <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("subvention_perc")} /></p>
                                                            <h3>{__.subvention_perc + "%"}</h3>
                                                        </Col>
                                                        <Col span={6}>
                                                            <p>Subvention Days: <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("subvention_days")} /></p>
                                                            <h3>{__.subvention_days}</h3>
                                                        </Col>
                                                    </React.Fragment>:null
                                                }
                                            </Col>
                                        ))
                                    }
                                   {_.scheme_type != 11 &&  <CheckActionPermission
                                        component={<Col className={"mt-10"} span={3}>
                                            <Button style={{ color: "#40a9ff", borderColor: "#40a9ff" }} onClick={() => this.editSp(true, _.min_normal_roi, _.id, _.overdue_tenor, _)}>+ Add</Button>
                                        </Col>}
                                        permission={this.props.schemeActionPermissions}
                                    />}

                                </Col>
                                <CheckActionPermission component={<Col className={"ml-10 mt-10"} span={24}>
                                    <Col className={"mb-10"} style={{ marginRight: "10px" }} span={4}>
                                        <Button className="text_blue" style={{ borderColor: "#40a9ff" }} href="https://s3.ap-south-1.amazonaws.com/los.progcap.com/media/public/BulkUploadDWD%26SP.xlsx">Download Template <Icon type={"download"} /></Button>
                                    </Col>
                                    <Col className={"mb-10"} offset={2} span={4}>
                                        <Upload
                                            loading={this.state.loading}
                                            onChange={({ file }) => {
                                                if (file.status === "uploading" && !this.state.loading) {
                                                    message.loading("Uploading...");
                                                    this.setState({
                                                        loading: true,
                                                        uploading_id: _.id
                                                    });
                                                }
                                                if (file.status === "done") {
                                                    this.setState({
                                                        loading: false,
                                                        uploading_id: ""
                                                    });
                                                    this.props.fetchCompanyLosSchemes(this.props.companyId);
                                                }
                                                if (file.status === "error") {
                                                    message.destroy();
                                                    message.error(file?.response?.non_field_errors || "Some Error Occured!");
                                                    this.setState({
                                                        loading: false,
                                                        uploading_id: ""
                                                    });
                                                }
                                            }}
                                            {...{
                                                directory: false, // Upload Directory Support
                                                multiple: false, // Upload Multiple files support,
                                                action:
                                                    `${process.env.BASE_URL}/company/${this.props.companyId}/scheme/${_.id}/dwd-sp/file-add/`,
                                                showUploadList: false,
                                                headers: {
                                                    Authorization: `Bearer ${getAuthToken().authToken}`
                                                },
                                                data: file => (file),

                                            }}
                                        >
                                            <Button className="text_blue" type={"default"} style={{ borderColor: "#1890ff", color: "#ffffff !important", backgroundColor: "#1890ff !important" }}>
                                                Upload{" "}
                                                <Icon
                                                    style={{
                                                        color: "#1890ff"
                                                    }}
                                                    type={
                                                        this.state.loading && this.state.uploading_id === _.id
                                                            ? "loading"
                                                            : "upload"
                                                    }
                                                    loading={this.state.uploading_id === _.id && this.state.loading}
                                                />
                                            </Button>
                                        </Upload>
                                    </Col>
                                </Col>} permission={this.props.schemeActionPermissions} />
                            </Panel>
                        </Collapse>
                    </Col>
                </div>
            </AntList.Item>
        );
    }

    renderPerUnitSubventionItem = (_, key) => {
        return (
            <AntList.Item
                key={key}
                className={
                    "border-none flex-column padless-card schemes-detail bg-white"
                }
            >
                <div className={"d-flex flex-row w-100 flex-wrap"}>
                    {
                        _._is_default_scheme && <Col span={24} style={{padding: "10px"}}>
                            <Tag color="geekblue">Default</Tag>
                        </Col>
                    }
                    <Col span={24}>
                        <Col span={24}>
                            <CheckActionPermission component={<div className={"d-flex m-5 pt-10 mt-10 mb-10 flex-row justify-content-space-between align-items-center"}>
                                <div className={"flex-row justify-content-space-between"} style={{display: "flex", width: "59%"}}>
                                    <Col span={24}>
                                        <Col span={8}>
                                            <p style={{ margin: "0px", marginLeft: "10px" }}>Scheme ID <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("scheme_id")} /><h3>{_.id || "--"}</h3></p>
                                        </Col>
                                        <Col span={8}>
                                            <p style={{ margin: "0px", marginLeft: "10px" }}>Unit <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("anchor_unit")} /><h3>{_.unit && _.unit.name || "--"}</h3></p>
                                        </Col>
                                        <Col span={8}>
                                            {
                                                _.anchor?.short_name && <p style={{ margin: "0px", marginLeft: "10px" }}>Anchor <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("anchor")} /><h3>{_.anchor?.short_name || "--"}</h3></p>
                                            }
                                        </Col>
                                    </Col>
                                </div>
                                {
                                    !_._is_default_scheme && <Col span={6} className={"d-flex flex-row-reverse m-5"} style={{ paddingRight: "16px" }}>
                                        <Button onClick={() => this.makeDefault(_.id)} type="primary"  style={{whiteSpace:"normal", height:"auto"}}>Set As Default {_.anchor?.short_name && " for " + _.anchor?.short_name}</Button>
                                    </Col>
                                }
                            </div>} permission={this.props.schemeActionPermissions} />
                        </Col>
                    </Col>
                    <Col className={"ml-10"} span={24}>
                        <Col span={24}>
                            <Col span={8}>
                                <p >Margin<GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("margin")} /><h3>{_.margin || "--"}</h3></p>
                            </Col>
                            <Col span={8}>
                                {
                                    _.tenor && <p>Tenor (days)<GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("tenor")} /><h3>{_.tenor || "--"}</h3></p>
                                }
                            </Col>
                            <Col span={8}>
                                {
                                    _.overdue_tenor && <p>Overdue Tenor (days)<GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("overdue_tenor")} /><h3>{_.overdue_tenor || "--"}</h3></p>
                                }
                            </Col>
                        </Col>
                    </Col>
                    <Col className={"ml-10"} span={24}>
                        <Col span={24}>
                            <Col span={8}>
                                <p>ROI Structure<GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("roiStructure")} /><h3>Flat</h3></p>
                            </Col>
                            <Col span={8}>
                                {
                                    <p>Min Normal ROI<GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("min_normal_roi")} /><h3>{_.min_min_normal_roi || "--"}</h3></p>
                                }
                            </Col>
                            <Col span={8}>
                                {
                                    <p>Max Normal ROI<GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("max_normal_roi")} /><h3>{_.min_normal_roi || "--"}</h3></p>
                                }
                            </Col>
                            <Col span={8}>
                                {
                                    <p>Overdue ROI<GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("tl_overdue_roi")} /><h3>{_.max_overdue_roi || "--"}</h3></p>
                                }
                            </Col>
                            <Col span={8}>
                                {
                                    <p>Actual Overdue ROI<h3>{_.additional_roi}</h3></p>
                                }
                            </Col>
                            <Col span={8}>
                                {
                                    <p>Is Adhoc Applicable On Overdue<h3>{_.is_adhoc_applicable_on_overdue ? "Yes" :  "No"}</h3></p>
                                }
                            </Col>
                        </Col>
                    </Col>
                    <Col className={"ml-10 mt-10"} span={24}>
                        <h3>ROI Schedule</h3>
                        {
                            _._roi_schedule_arr.map((__, k) => (
                                <Col className={"mb-10"} key={k} span={24}>
                                    <Col span={6}>
                                        <p>From Days:</p>
                                        <h3>{__.from_days}</h3>
                                    </Col>
                                    <Col span={6}>
                                        <p>To Days:</p>
                                        <h3>{__.to_days}</h3>
                                    </Col>
                                    <Col span={6}>
                                        <p>ROI:</p>
                                        <h3>{__.roi}</h3>
                                    </Col>
                                    <Col span={6}>
                                        <p>Adhoc ROI:</p>
                                        {<h3>{__.adhoc_roi}</h3>}
                                    </Col>
                                </Col>
                            ))
                        }
                        <Col span={24}>
                            <Col span={8}>
                                {
                                    <p>Stop Billing Days<GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("stop_billing_days")} /><h3>{_.stop_billing_days || "--"}</h3></p>
                                }
                            </Col>
                            <Col span={8}>
                                {
                                    <p>Cooling Period<GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("cooling_period")} /><h3>{_.cooling_period || "--"}</h3></p>
                                }
                            </Col>
                            <Col span={8}>
                                {
                                    <p>Dealer Cashback %<GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("dealer_perc")} /><h3>{_.cashback_sharing_percentage_for_dealer || "--"}</h3></p>
                                }
                            </Col>
                        </Col>
                        <Col span={24}>
                            <Col span={8}>
                                <p>Seller Cashback %<GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("seller_perc")} /><h3>{_.cashback_sharing_percentage_for_seller || "--"}</h3></p>
                            </Col>
                            <Col span={8}>
                                <p>Progcap Cashback %<GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("progcap_perc")} /><h3>{_.cashback_sharing_percentage_for_progcap || "--"}</h3></p>
                            </Col>
                        </Col>
                    </Col>
                    <Col className={"ml-10 mt-10"} span={24}>
                        <Col span={6}>
                            <p>Disbursal Wait Days: <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("disbursal_wait_days")} /></p>
                            <h3>{_.dwd_sp_default.disbursal_wait_days}</h3>
                        </Col>
                        <Col span={6}>
                            <p>Subvention Days: <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("subvention_days")} /></p>
                            <h3>{_.dwd_sp_default.subvention_days}</h3>
                        </Col>
                        <Col span={6}>
                            <p>Subvention Amount Per Unit <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("subvention_amount_per_unit")} /></p>
                            <h3>{_.dwd_sp_default.subvention_per_unit}</h3>
                        </Col>
                        <CheckActionPermission
                            component={<Button style={{ marginTop: "10px", color: "#40a9ff", borderColor: "#40a9ff" }} onClick={() => this.setState({openModalSubventionScheme: true, schemeId: _.id, anchorUnit: _.anchor && _.anchor.units && _.anchor.units[0].name, minNormalRoi: _.min_min_normal_roi, maxNormalRoi: _.min_normal_roi})}>Edit</Button>}
                            permission={this.props.schemeActionPermissions}
                        />
                    </Col>
                    <Col span={24} style={{ marginTop: "20px" }}>
                        <Collapse defaultActiveKey={["1"]} >
                            <Panel header="Flexible Parameters:-" key="1">
                                <Col className={"ml-10 mt-10"} span={24}>
                                    {
                                        _.new_dw_sp_all.map((__, k) => (
                                            <Col className={"mb-10"} key={k} span={18}>
                                                <Col span={6}>
                                                    <p>Disbursal Wait days: <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("disbursal_wait_days")} /></p>
                                                    <h3>{__.disbursal_wait_days}</h3>
                                                </Col>
                                                <Col span={6}>
                                                    <p>Subvention Days: <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("subvention_days")} /></p>
                                                    <h3>{__.subvention_days}</h3>
                                                </Col>
                                                <Col span={6}>
                                                    <p>Subvention Amount Per Unit <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("subvention_amount_per_unit")} /></p>
                                                    <h3>{__.subvention_per_unit}</h3>
                                                </Col>
                                            </Col>
                                        ))
                                    }
                                    <CheckActionPermission
                                        component={<Col className={"mt-10"} span={3}>
                                            <Button style={{ color: "#40a9ff", borderColor: "#40a9ff" }} onClick={() => this.setState({addSubventionScheme: true, schemeId: _.id})}>+ Add</Button>
                                        </Col>}
                                        permission={this.props.schemeActionPermissions}
                                    />

                                </Col>
                                <CheckActionPermission component={<Col className={"ml-10 mt-10"} span={24}>
                                    <Col className={"mb-10"} style={{ marginRight: "10px" }} span={4}>
                                        <Button className="text_blue" style={{ borderColor: "#40a9ff" }} href="https://s3.ap-south-1.amazonaws.com/los.progcap.com/media/public/BulkUploadDWD%26SP.xlsx">Download Template <Icon type={"download"} /></Button>
                                    </Col>
                                    <Col className={"mb-10"} offset={2} span={4}>
                                        <Upload
                                            loading={this.state.loading}
                                            onChange={({ file }) => {
                                                if (file.status === "uploading" && !this.state.loading) {
                                                    message.loading("Uploading...");
                                                    this.setState({
                                                        loading: true,
                                                        uploading_id: _.id
                                                    });
                                                }
                                                if (file.status === "done") {
                                                    this.setState({
                                                        loading: false,
                                                        uploading_id: ""
                                                    });
                                                    this.props.fetchCompanyLosSchemes(this.props.companyId);
                                                }
                                                if (file.status === "error") {
                                                    message.destroy();
                                                    message.error(file?.response?.non_field_errors || "Some Error Occured!");
                                                    this.setState({
                                                        loading: false,
                                                        uploading_id: ""
                                                    });
                                                }
                                            }}
                                            {...{
                                                directory: false, // Upload Directory Support
                                                multiple: false, // Upload Multiple files support,
                                                action:
                                                    `${process.env.BASE_URL}/company/${this.props.companyId}/scheme/${_.id}/dwd-sp/file-add/`,
                                                showUploadList: false,
                                                headers: {
                                                    Authorization: `Bearer ${getAuthToken().authToken}`
                                                },
                                                data: file => (file),

                                            }}
                                        >
                                            <Button className="text_blue" type={"default"} style={{ borderColor: "#1890ff", color: "#ffffff !important", backgroundColor: "#1890ff !important" }}>
                                                Upload{" "}
                                                <Icon
                                                    style={{
                                                        color: "#1890ff"
                                                    }}
                                                    type={
                                                        this.state.loading && this.state.uploading_id === _.id
                                                            ? "loading"
                                                            : "upload"
                                                    }
                                                    loading={this.state.uploading_id === _.id && this.state.loading}
                                                />
                                            </Button>
                                        </Upload>
                                    </Col>
                                </Col>} permission={this.props.schemeActionPermissions} />
                            </Panel>
                        </Collapse>
                    </Col>
                </div>
            </AntList.Item>
        );
    }

    renderCombinationalListItem = (_, key) => {
        return (
            <AntList.Item
                key={key}
                className={
                    "border-none flex-column padless-card schemes-detail bg-white"
                }
            >
                <div className={"d-flex flex-row w-100 flex-wrap"}>
                    {
                        _._is_default_scheme && <Col span={24} style={{padding: "10px"}}>
                            <Tag color="geekblue">Default</Tag>
                        </Col>
                    }
                    {
                        _.lending_partner ? <Col className={"ml-10"} span={24}>
                            <div>
                                <p style={{ margin: "0px" }}>Lending Partner <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("lending_partner")} /></p>
                                <h3>{_.lending_partner.short_name}</h3>
                            </div>
                        </Col>:null
                    }
                    <Col span={24}>
                        <Col span={24}>
                            <CheckActionPermission component={<div className={"d-flex m-5 pt-10 mt-10 mb-10 flex-row justify-content-space-between align-items-center"}>
                                <div className={"flex-row justify-content-space-between"} style={{display: "flex", width: "45%"}}>
                                    <p style={{ margin: "0px", marginLeft: "10px" }}>Scheme ID <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("scheme_id")} /><h3>{_.id}</h3></p>
                                    {
                                        _.anchor?.short_name && <p style={{ margin: "0px", marginLeft: "100px" }}>Anchor <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("anchor")} /><h3>{_.anchor?.short_name}</h3></p>
                                    }
                                </div>
                                {
                                    !_._is_default_scheme && <Col span={6} className={"d-flex flex-row-reverse m-5"} style={{ paddingRight: "16px" }}>
                                        <Button onClick={() => this.makeDefault(_.id)} type="primary">Set As Default {_.anchor?.short_name && " for " + _.anchor?.short_name}</Button>
                                    </Col>
                                }
                            </div>} permission={this.props.schemeActionPermissions} />
                        </Col>
                    </Col>
                    {/* <Col className={"ml-10"} span={24}>
                        <div>
                            <p style={{ margin: "0px" }}>Scheme ID <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("scheme_id")} /></p>
                            <h3>{_.id}</h3>
                        </div>
                    </Col> */}
                    <Col className={"ml-10"} span={24}>
                        {_.newSchemeThreeFirstSection.map((__, k) => (
                            <Col className={"mb-10"} key={k} span={7}>
                                <Statistic
                                    valueStyle={{
                                        fontSize: "16px",
                                        fontWeight: 600
                                    }}
                                    title={<span>{__[0]}  {fieldsKeys(__[0]) ? <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get(fieldsKeys(__[0]))} /> : null}</span>}
                                    value={ this.showRoiToUser(__[0] , __[1])}
                                        //  __[0]== "Actual Overdue ROI" && !this.props.roi_permissions ? "Actual Overdue ROI" :  __[1]}
                                // suffix={<span style={{fontSize: "12px"}}><Icon type="info" /><span>{__[2]}</span></span>}
                                />
                            </Col>
                        ))}
                    </Col> 
                    <Col className={"ml-10 mt-10"} span={24}>
                        <h3>ROI Schedule</h3>
                        {
                            _._roi_schedule_arr.map((__, k) => (
                                <Col className={"mb-10"} key={k} span={24}>
                                    <Col span={6}>
                                        <p>From Days:</p>
                                        <h3>{__.from_days}</h3>
                                    </Col>
                                    <Col span={6}>
                                        <p>To Days:</p>
                                        <h3>{__.to_days}</h3>
                                    </Col>
                                    <Col span={6}>
                                        <p>ROI:</p>
                                        <h3>{this.props.roi_permissions ? __.roi : "ROI"}</h3>
                                    </Col>
                                    <Col span={6}>
                                        <p>Adhoc ROI:</p>
                                        {<h3>{this.props.roi_permissions ? __.adhoc_roi : "Adhoc ROI"}</h3>}
                                    </Col>
                                </Col>
                            ))
                        }
                        {_.newSchemeSecThree.map((__, k) => (
                            <Col className={"mb-10"} key={k} span={6}>
                                <Statistic
                                    valueStyle={{
                                        fontSize: "16px",
                                        fontWeight: 600
                                    }}
                                    title={<span>{__[0]}  {fieldsKeys(__[0]) ? <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get(fieldsKeys(__[0]))} /> : null}</span>}
                                    value={__[1]}
                                />
                            </Col>
                        ))}
                    </Col>
                    <Col className={"ml-10 mt-10"} span={24}>
                        <Col span={6}>
                            <p>Disbursal Wait Days: <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("disbursal_wait_days")} /></p>
                            <h3>{_.dwd_sp_default.disbursal_wait_days}</h3>
                        </Col>
                        <Col span={6}>
                            <p>Subvention %: <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("subvention_perc")} /></p>
                            <h3>{_.dwd_sp_default.subvention_perc + "%"}</h3>
                        </Col>
                        <Col span={6}>
                            <p>Subvention Days: <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("subvention_days")} /></p>
                            <h3>{_.dwd_sp_default.subvention_days}</h3>
                        </Col>
                        {/* {_.newSchemeEditFirstSec.map((__, k) => (
                            <Col className={"mb-10"} key={k} span={6}>
                                <Statistic
                                    valueStyle={{
                                        fontSize: "16px",
                                        fontWeight: 600
                                    }}
                                    title={__[0]}
                                    value={__[1]}
                                />
                            </Col>
                        ))} */}
                        <CheckActionPermission
                            component={<Button style={{ marginTop: "10px", color: "#40a9ff", borderColor: "#40a9ff" }} onClick={() => this.editDefaultSp(false, _.dwd_sp_default, _.min_normal_roi, _.id, _.overdue_tenor, _ , true)}>Edit</Button>}
                            permission={this.props.schemeActionPermissions}
                        />
                    </Col>
                    <Col span={24} style={{ marginTop: "20px" }}>
                        <Collapse defaultActiveKey={["1"]} >
                            <Panel header="Flexible Parameters:-" key="1">
                                <Col className={"ml-10 mt-10"} span={24}>
                                    {
                                        _.new_dw_sp_all.map((__, k) => (
                                            <Col className={"mb-10"} key={k} span={18}>
                                                <Col span={6}>
                                                    <p>Disbursal Wait days: <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("disbursal_wait_days")} /></p>
                                                    <h3>{__.disbursal_wait_days}</h3>
                                                </Col>
                                                <Col span={6}>
                                                    <p>Subvention %: <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("subvention_perc")} /></p>
                                                    <h3>{__.subvention_perc + "%"}</h3>
                                                </Col>
                                                <Col span={6}>
                                                    <p>Subvention Days: <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("subvention_days")} /></p>
                                                    <h3>{__.subvention_days}</h3>
                                                </Col>
                                            </Col>
                                        ))
                                    }
                                    <CheckActionPermission
                                        component={<Col className={"mt-10"} span={3}>
                                            <Button style={{ color: "#40a9ff", borderColor: "#40a9ff" }} onClick={() => this.editSp(true, _.min_normal_roi, _.id, _.overdue_tenor, _ , true)}>+ Add</Button>
                                        </Col>}
                                        permission={this.props.schemeActionPermissions}
                                    />

                                </Col>
                                <CheckActionPermission component={<Col className={"ml-10 mt-10"} span={24}>
                                    <Col className={"mb-10"} style={{ marginRight: "10px" }} span={4}>
                                        <Button className="text_blue" style={{ borderColor: "#40a9ff" }} href="https://s3.ap-south-1.amazonaws.com/los.progcap.com/media/public/BulkUploadDWD%26SP.xlsx">Download Template <Icon type={"download"} /></Button>
                                    </Col>
                                    <Col className={"mb-10"} offset={2} span={4}>
                                        <Upload
                                            loading={this.state.loading}
                                            onChange={({ file }) => {
                                                if (file.status === "uploading" && !this.state.loading) {
                                                    message.loading("Uploading...");
                                                    this.setState({
                                                        loading: true,
                                                        uploading_id: _.id
                                                    });
                                                }
                                                if (file.status === "done") {
                                                    this.setState({
                                                        loading: false,
                                                        uploading_id: ""
                                                    });
                                                    this.props.fetchCompanyLosSchemes(this.props.companyId);
                                                }
                                                if (file.status === "error") {
                                                    message.destroy();
                                                    message.error(file?.response?.non_field_errors || "Some Error Occured!");
                                                    this.setState({
                                                        loading: false,
                                                        uploading_id: ""
                                                    });
                                                }
                                            }}
                                            {...{
                                                directory: false, // Upload Directory Support
                                                multiple: false, // Upload Multiple files support,
                                                action:
                                                    `${process.env.BASE_URL}/company/${this.props.companyId}/scheme/${_.id}/dwd-sp/file-add/`,
                                                showUploadList: false,
                                                headers: {
                                                    Authorization: `Bearer ${getAuthToken().authToken}`
                                                },
                                                data: file => (file),

                                            }}
                                        >
                                            <Button className="text_blue" type={"default"} style={{ borderColor: "#1890ff", color: "#ffffff !important", backgroundColor: "#1890ff !important" }}>
                                                Upload{" "}
                                                <Icon
                                                    style={{
                                                        color: "#1890ff"
                                                    }}
                                                    type={
                                                        this.state.loading && this.state.uploading_id === _.id
                                                            ? "loading"
                                                            : "upload"
                                                    }
                                                    loading={this.state.uploading_id === _.id && this.state.loading}
                                                />
                                            </Button>
                                        </Upload>
                                    </Col>
                                </Col>} permission={this.props.schemeActionPermissions} />
                            </Panel>
                        </Collapse>
                    </Col>
                </div>
            </AntList.Item>
        );
    }

    renderCashCardListItem = (_, key) => {
        return (
            <AntList.Item
                key={key}
                className={
                    "border-none flex-column padless-card schemes-detail bg-white"
                }
            >
                <div className={"d-flex flex-row w-100 flex-wrap"}>
                    {
                        _._is_default_scheme && <Col span={24} style={{padding: "10px"}}>
                            <Tag color="geekblue">Default</Tag>
                        </Col>
                    }
                    {
                        _.lending_partner ? <Col className={"ml-10"} span={24}>
                            <div>
                                <p style={{ margin: "0px" }}>Lending Partner <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("lending_partner")} /></p>
                                <h3>{_.lending_partner.short_name}</h3>
                            </div>
                        </Col>:null
                    }
                    <Col span={24}>
                        <Col span={24}>
                            <CheckActionPermission component={<div className={"d-flex m-5 pt-10 mt-10 mb-10 flex-row justify-content-space-between align-items-center"}>
                                <div className={"flex-row justify-content-space-between"} style={{display: "flex", width: "45%"}}>
                                    <p style={{ margin: "0px", marginLeft: "10px" }}>Scheme ID <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("scheme_id")} /><h3>{_.id}</h3></p>
                                    {
                                        _.anchor?.short_name && <p style={{ margin: "0px", marginLeft: "100px" }}>Anchor <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("anchor")} /><h3>{_.anchor?.short_name}</h3></p>
                                    }
                                </div>
                                {
                                    !_._is_default_scheme && <Col span={6} className={"d-flex flex-row-reverse m-5"} style={{ paddingRight: "16px" }}>
                                        <Button onClick={() => this.makeDefault(_.id)} type="primary">Set As Default {_.anchor?.short_name && " for " + _.anchor?.short_name}</Button>
                                    </Col>
                                }
                            </div>} permission={this.props.schemeActionPermissions} />
                        </Col>
                    </Col>
                    {/* <Col className={"ml-10"} span={24}>
                        <div>
                            <p style={{ margin: "0px" }}>Scheme ID <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("scheme_id")} /></p>
                            <h3>{_.id}</h3>
                        </div>
                    </Col> */}
                    <Col className={"ml-10"} span={24}>
                        {_.newSchemeFirstSection.map((__, k) => (
                            <Col className={"mb-10"} key={k} span={7}>
                                <Statistic
                                    valueStyle={{
                                        fontSize: "16px",
                                        fontWeight: 600
                                    }}
                                    title={<span>{__[0]}  {fieldsKeys(__[0]) ?  <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get(fieldsKeys(__[0]))} /> : null}</span>}
                                    value={__[1]}
                                    // suffix={<span style={{fontSize: "12px"}}><Icon type="info" /><span>{__[2]}</span></span>}
                                />
                            </Col>
                        ))}
                    </Col>
                    <Col className={"ml-10 mt-10"} span={24}>
                        <h3>Cash Card Schedule</h3>
                        {
                            _.toJS().cash_cards_schedule.map((__, k) => (
                                <Col className={"mb-10"} key={k} span={24}>
                                    <Col span={7}>
                                        <p>Start Day</p>
                                        <h3>{__.start_day}</h3>
                                    </Col>
                                    <Col span={7}>
                                        <p>End Day:</p>
                                        <h3>{__.end_day}</h3>
                                    </Col>
                                </Col>
                            ))
                        }
                    </Col>
                    <Col className={"ml-10 mt-10"} span={24}>
                        <h3>ROI Schedule</h3>
                        {
                            _._roi_schedule_arr.map((__, k) => (
                                <Col className={"mb-10"} key={k} span={24}>
                                    <Col span={6}>
                                        <p>From Days:</p>
                                        <h3>{__.from_days}</h3>
                                    </Col>
                                    <Col span={6}>
                                        <p>To Days:</p>
                                        <h3>{__.to_days}</h3>
                                    </Col>
                                    <Col span={6}>
                                        <p>ROI:</p>
                                        <h3>{__.roi}</h3>
                                    </Col>
                                    <Col span={6}>
                                        <p>Adhoc ROI:</p>
                                        {<h3>{ __.adhoc_roi}</h3>}
                                    </Col>
                                </Col>
                            ))
                        }
                        {_.newSchemeSecThree.map((__, k) => (
                            <Col className={"mb-10"} key={k} span={6}>
                                <Statistic
                                    valueStyle={{
                                        fontSize: "16px",
                                        fontWeight: 600
                                    }}
                                    title={<span>{__[0]}  {fieldsKeys(__[0]) ? <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get(fieldsKeys(__[0]))} /> : null}</span>}
                                    value={__[1]}
                                />
                            </Col>
                        ))}
                    </Col>
                    <Col className={"ml-10 mt-10"} span={24}>
                        <Col span={6}>
                            <p>Disbursal Wait Days: <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("disbursal_wait_days")} /></p>
                            <h3>{_.dwd_sp_default.disbursal_wait_days}</h3>
                        </Col>
                        <Col span={6}>
                            <p>Subvention %: <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("subvention_perc")} /></p>
                            <h3>{_.dwd_sp_default.subvention_perc + "%"}</h3>
                        </Col>
                        <Col span={6}>
                            <p>Subvention Days: <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("subvention_days")} /></p>
                            <h3>{_.dwd_sp_default.subvention_days}</h3>
                        </Col>
                        {/* {_.newSchemeEditFirstSec.map((__, k) => (
                            <Col className={"mb-10"} key={k} span={6}>
                                <Statistic
                                    valueStyle={{
                                        fontSize: "16px",
                                        fontWeight: 600
                                    }}
                                    title={__[0]}
                                    value={__[1]}
                                />
                            </Col>
                        ))} */}
                        <CheckActionPermission
                            component={<Button style={{ marginTop: "10px", color: "#40a9ff", borderColor: "#40a9ff" }} onClick={() => this.editDefaultSp(false, _.dwd_sp_default, _.min_normal_roi, _.id, _.overdue_tenor, _)}>Edit</Button>}
                            permission={this.props.schemeActionPermissions}
                        />
                    </Col>
                    <Col span={24} style={{ marginTop: "20px" }}>
                        <Collapse  defaultActiveKey={["1"]} >
                            <Panel header="Flexible Parameters:-" key="1">
                                <Col className={"ml-10 mt-10"} span={24}>
                                    {
                                        _.new_dw_sp_all.map((__, k) => (
                                            <Col className={"mb-10"} key={k} span={18}>
                                                <Col span={6}>
                                                    <p>Disbursal Wait days: <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("disbursal_wait_days")} /></p>
                                                    <h3>{__.disbursal_wait_days}</h3>
                                                </Col>
                                                <Col span={6}>
                                                    <p>Subvention %: <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("subvention_perc")} /></p>
                                                    <h3>{__.subvention_perc + "%"}</h3>
                                                </Col>
                                                <Col span={6}>
                                                    <p>Subvention Days: <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("subvention_days")} /></p>
                                                    <h3>{__.subvention_days}</h3>
                                                </Col>
                                            </Col>
                                        ))
                                    }
                                    <CheckActionPermission
                                        component={<Col className={"mt-10"} span={3}>
                                            <Button style={{ color: "#40a9ff", borderColor: "#40a9ff" }} onClick={() => this.editSp(true, _.min_normal_roi, _.id, _.overdue_tenor, _)}>+ Add</Button>
                                        </Col>}
                                        permission={this.props.schemeActionPermissions}
                                    />

                                </Col>
                                <CheckActionPermission component={<Col className={"ml-10 mt-10"} span={24}>
                                    <Col className={"mb-10"} style={{ marginRight: "10px" }} span={4}>
                                        <Button className="text_blue" style={{ borderColor: "#40a9ff" }} href="https://s3.ap-south-1.amazonaws.com/los.progcap.com/media/public/BulkUploadDWD%26SP.xlsx">Download Template <Icon type={"download"} /></Button>
                                    </Col>
                                    <Col className={"mb-10"} offset={2} span={4}>
                                        <Upload
                                            loading={this.state.loading}
                                            onChange={({ file }) => {
                                                if (file.status === "uploading" && !this.state.loading) {
                                                    message.loading("Uploading...");
                                                    this.setState({
                                                        loading: true,
                                                        uploading_id: _.id
                                                    });
                                                }
                                                if (file.status === "done") {
                                                    this.setState({
                                                        loading: false,
                                                        uploading_id: ""
                                                    });
                                                    this.props.fetchCompanyLosSchemes(this.props.companyId);
                                                }
                                                if (file.status === "error") {
                                                    message.destroy();
                                                    message.error(file?.response?.non_field_errors || "Some Error Occured!");
                                                    this.setState({
                                                        loading: false,
                                                        uploading_id: ""
                                                    });
                                                }
                                            }}
                                            {...{
                                                directory: false, // Upload Directory Support
                                                multiple: false, // Upload Multiple files support,
                                                action:
                                                    `${process.env.BASE_URL}/company/${this.props.companyId}/scheme/${_.id}/dwd-sp/file-add/`,
                                                showUploadList: false,
                                                headers: {
                                                    Authorization: `Bearer ${getAuthToken().authToken}`
                                                },
                                                data: file => (file),

                                            }}
                                        >
                                            <Button className="text_blue" type={"default"} style={{ borderColor: "#1890ff", color: "#ffffff !important", backgroundColor: "#1890ff !important" }}>
                                                Upload{" "}
                                                <Icon
                                                    style={{
                                                        color: "#1890ff"
                                                    }}
                                                    type={
                                                        this.state.loading && this.state.uploading_id === _.id
                                                            ? "loading"
                                                            : "upload"
                                                    }
                                                    loading={this.state.uploading_id === _.id && this.state.loading}
                                                />
                                            </Button>
                                        </Upload>
                                    </Col>
                                </Col>} permission={this.props.schemeActionPermissions} />
                            </Panel>
                        </Collapse>
                    </Col>
                </div>
            </AntList.Item>
        );
    }

    returnInstalmentFreq=(item, daySet)=>{
        if(item == 1){
            return "Custom";
        }else if(item == 2){
            return "Monthly";
        }
        // else if(item == 7){
        //     return "Weekly";
        // }else if(item == 365){
        //     return "Yearly";
        // }else{
        //     return "Custom";
        // }
    }

    returnInstalmentFreqUnit=(item, daySet)=>{
        if(daySet == 1){
            return "Day(s)";
        }else if(daySet == null){
            return "Month(s)";
        }else if(daySet == 7){
            return "Week(s)";
        }else if(daySet == 365){
            return "Year(s)";
        }else{
            return "Custom";
        }
    }

    returnDaySet=(daySet)=>{
        if(daySet == 1){
            return null;
        }else if(daySet == null){
            return null;
        }else if(daySet == 7){
            return null;
        }else if(daySet == 365){
            return null;
        }else{
            return daySet + " Day(s)";
        }  
    }
    
    renderIndianFormatAmount=(amount)=>{
        var x=amount;
        x=x.toString();
        var afterPoint = "";
        if(x.indexOf(".") > 0)
            afterPoint = x.substring(x.indexOf("."),x.length);
        x = Math.floor(x);
        x=x.toString();
        var lastThree = x.substring(x.length-3);
        var otherNumbers = x.substring(0,x.length-3);
        if(otherNumbers != "")
            lastThree = "," + lastThree;
        var res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree + afterPoint;
        return res;
    }

    renderTermLoan = (_, key) => {
        return (
            <AntList.Item
                key={key}
                className={
                    "border-none flex-column padless-card schemes-detail bg-white"
                }
            >
                <div className={"d-flex flex-row w-100 flex-wrap"}>
                    {
                        _._is_default_scheme && <Col span={24} style={{padding: "10px"}}>
                            <Tag color="geekblue">Default</Tag>
                        </Col>
                    }
                    {
                        _.lending_partner ? <Col className={"ml-10"} span={24}>
                            <div>
                                <p style={{ margin: "0px" }}>Lending Partner <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("lending_partner")} /></p>
                                <h3>{_.lending_partner.short_name}</h3>
                            </div>
                        </Col>:null
                    }
                    <Col span={24}>
                        <Col span={24}>
                            <CheckActionPermission component={<div className={"m-5 mt-10 mb-10 align-items-center"}>
                                {
                                    !_._is_default_scheme &&<Row> <Col span={24} className={"d-flex flex-row-reverse m-5"} style={{ paddingRight: "16px" }}>
                                        <Button  onClick={() => this.makeDefault(_.id)} type="primary">Set As Default {_.anchor?.short_name && " for " + _.anchor?.short_name}</Button>
                                    </Col></Row>
                                }
                                <div className={"flex-row pt-10 justify-content-space-between"} style={{ display: "flex", width: "45%" }}>
                                    <Col span={24}>
                                        <Col span={12}>
                                            <p style={{ margin: "0px", marginLeft: "10px" }}>TL-Scheme ID <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("scheme_id")} /><h3>{_.id}</h3></p>
                                        </Col>
                                        <Col span={12}>
                                            {_.anchor?.short_name &&
                                                <p>Anchor <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("anchor")} />
                                                    <h3>{_.anchor?.short_name}</h3>
                                                </p>}
                                        </Col>
                                    </Col>
                                </div>

                            </div>} permission={this.props.schemeActionPermissions} />
                        </Col>
                    </Col>
                    <Col className={"ml-10"} span={24}>
                        {/* {_.newTermLoanSchemeFirstSection.filter(item => item[0] !== "Margin" || item[0] !== "Normal ROI" || item[0] !== "Overdue ROI").map((__, k) => (
                            <Col className={"mb-10"} key={k} span={7}>
                                <Statistic
                                    valueStyle={{
                                        fontSize: "16px",
                                        fontWeight: 600
                                    }}
                                    title={<span>{__[0]}  {fieldsKeys(__[0]) ?  <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get(fieldsKeys(__[0]))} /> : null}</span>}
                                    value={__[1]}
                                    // suffix={<span style={{fontSize: "12px"}}><Icon type="info" /><span>{__[2]}</span></span>}
                                />
                            </Col>
                        ))} */}
                        <Col span={7}>
                            <p>Normal ROI: <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("tl_normal_roi")} /></p>
                            <h3>{_.min_normal_roi}%</h3>
                        </Col>
                        <Col span={7}>
                            <p>Overdue ROI: <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("tl_overdue_roi")} /></p>
                            <h3>{_.max_overdue_roi}%</h3>
                        </Col>
                        <Col span={7}>
                            <p>Margin:</p>
                            <h3>{_.margin}%</h3>
                        </Col>
                    </Col>
                    <Col className={"ml-10 mt-10"} span={24}>
                        {/* <h3>Term Loan</h3> */}
                        {
                            _.toJS().term_loan_parameters.map((__, k) => {
                                const subvention_sub_program_type = SubventionType.find(_ => _.value == __.subvention_sub_program_type);

                                return <Col className={"mb-10"} key={k} span={24}>
                                    <Row className="mb-10">
                                        <Col span={7}>
                                            <p>Interest Type: <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("interest_type")} /></p>
                                            <h3>{InterestType.filter((item) => item.value == __.interest_type)[0]?.label}</h3>
                                        </Col>
                                        <Col span={7}>
                                            <p>Instalment Frequency: <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("instalment_frequency")} /></p>
                                            <h3>{this.returnInstalmentFreq(__.instalment_frequency, __.day_set)}</h3>
                                        </Col>
                                        {
                                            this.returnDaySet(__.day_set)?<Col span={7}>
                                                <p>Custom Frequency (in days): <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("")} /></p>
                                                <h3>{this.returnDaySet(__.day_set)}</h3>
                                            </Col>:<Col span={7}></Col>
                                        }
                                    </Row>
                                    <Row className="mb-10">
                                        <Col span={7}>
                                            <p>Minimum loan amount: <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("minimum_loan_amount")} /></p>
                                            <h3>{this.renderIndianFormatAmount(__.loan_amount_min)}</h3>
                                        </Col>
                                        <Col span={7}>
                                            <p>Maximum loan amount: <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("maximum_loan_amount")} /></p>
                                            <h3>{this.renderIndianFormatAmount(__.loan_amount_max)}</h3>
                                        </Col>
                                        <Col span={7}></Col>
                                    </Row>
                                    <Row className="mb-10">
                                        <Col span={7}>
                                            <p>Minimun Loan Tenure: <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("minimum_loan_tenure")} /></p>
                                            <h3>{this.returnDaySet(__.day_set)?(__.min_instalment_count*__.day_set)+" Day(s)":__.min_instalment_count+" "+this.returnInstalmentFreqUnit(__.instalment_frequency, __.day_set)}</h3>
                                        </Col>
                                        <Col span={7}>
                                            <p>Maximum loan tenure: <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("maximum_loan_tenure")} /></p>
                                            <h3>{this.returnDaySet(__.day_set)?(__.max_instalment_count*__.day_set)+" Day(s)":__.max_instalment_count+" "+this.returnInstalmentFreqUnit(__.instalment_frequency, __.day_set)}</h3>
                                        </Col>
                                        {/* <Col span={7}>
                                            <p>Buyer Subvention Days:</p>
                                            <h3>{__.buyer_subvention_days}</h3>
                                        </Col> */}
                                    </Row>
                                    <Row>
                                        
                                    <Col span={7}>
                                            <p>Subvention Applicable:</p>
                                            <h3>{__.subvention_program_type == 0 ? "No" : "Yes"}</h3>
                                        </Col>
                                        <Col span={7}>
                                            <p>Subvention (%): <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("upfront_interest_deduction")} /></p>
                                            <h3>{__.upfront_interest_percentage}%</h3>
                                        </Col>
                                        <Col span={7}>
                                            <p>Subvention Type: <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("upfront_interest_deduction")} /></p>
                                            <h3>{subvention_sub_program_type ? subvention_sub_program_type.label : "-"}</h3>
                                        </Col>
                                    </Row>
                                    <Row className="mb-10">
                                        <Col span={7}>
                                            <p>Subvention Days:</p>
                                            <h3>{__.buyer_subvention_days == null ? "N/A": __.buyer_subvention_days}</h3>
                                        </Col>
                                        <Col span={7}>
                                            <p>Grace Period for OD Fee: <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("grace_period_for_od_interest")} /></p>
                                            <h3>{__.grace_period_od_interest}</h3>
                                        </Col>
                                        {/* <Col span={7}>
                                            <p>Seller Subvention Days:</p>
                                            <h3>{__.seller_subvention_days}</h3>
                                        </Col> */}
                                    </Row>
                                    <Col span={7}>
                                        <p>Instalment Date Calculation: <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("instalment_date_calculation")} /></p>
                                        <h3>{InstalmentDateCalculation.filter((item) => item.value == __.instalment_date_type)[0]?.label}</h3>
                                    </Col>
                                    {/* {
                                        __.instalment_date_type==2 ?<Col span={7}>
                                            <p>Grace Period for first Instalment Date: <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("")} /></p>
                                            <h3>{this.returnDaySet(__.day_set)?(__.grace_day_set_count*__.day_set)+" Day(s)":__.grace_day_set_count+" "+this.returnInstalmentFreqUnit(__.instalment_frequency, __.day_set)}</h3>
                                        </Col>:null
                                    } */}
                                    {
                                        __.fixed_emi_cut_off_date && __.instalment_date_type==1?<Col span={7}>
                                            <p>Fixed EMI Cut-off Date: <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("fixed_emi_cut_off_date")} /></p>
                                            <h3>{__.fixed_emi_cut_off_date}</h3>
                                        </Col>:null
                                    }
                                    {
                                        __.fixed_emi_date && __.instalment_date_type==1?<Col span={7}>
                                            <p>Fixed EMI Date: <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("fixed_emi_date")} /></p>
                                            <h3>{__.fixed_emi_date}</h3>
                                        </Col>:null
                                    }
                                    {
                                        __.max_moratorium_period != null?<Col span={7}>
                                            <p>Max Moratorium Period:</p>
                                            <h3>{__.max_moratorium_period}</h3>
                                        </Col>:null
                                    }
                                    {__.is_moratorium_interest_charged != null ? <Col span={7}>
                                        <p>Moratorium Interest Charges:</p>
                                        <h3>{__.is_moratorium_interest_charged ? "Yes" : "No"}</h3>
                                    </Col> : null
                                    }
                                    {__.is_principal_in_first_instalment_after_moratorium != null ? <Col span={7}>
                                        <p>First Instalment After Moratorium:</p>
                                        <h3>{__.is_principal_in_first_instalment_after_moratorium ? "No" : "Yes"}</h3>
                                    </Col> : null
                                    }
                                    {__.cut_off_days != null ? <Col span={7}>
                                        <p>Cut-off Days:</p>
                                        <h3>{__.cut_off_days}</h3>
                                    </Col> : null
                                    }
                                    {__.custom_day_set != null ? <Col span={7}>
                                        <p>Fixed EMI dates:</p>
                                        <h3>{__.custom_day_set.length ? __.custom_day_set.join(", ") : "-"}</h3>
                                    </Col> : null
                                    }
                                </Col>
                            })
                        }
                    </Col>


                    <Col className={"ml-10 mt-10"} span={24}>
                        <h3>ROI Schedule</h3>
                        {
                            _.normal_roi_schedule && _.normal_roi_schedule.map((__, k) => (
                                <Col className={"mb-10"} key={k} span={24}>
                                    <Col span={7}>
                                        <p>From Days:</p>
                                        <h3>{__.from_days}</h3>
                                    </Col>
                                    <Col span={7}>
                                        <p>To Days:</p>
                                        <h3>{__.to_days}</h3>
                                    </Col>
                                    <Col span={7}>
                                        <p>ROI:</p>
                                        {!this.props.roi_permissions ? <h3>{k == 0 && ['18.250%', '18.25'].includes(__.roi.toString()) ? "Normal ROI" : k + 1 == _._roi_schedule_arr.length && ["27.375%", "27.375"].includes(__.roi.toString()) ? "Overdue ROI" : __.roi.toFixed(4)}</h3>
                                            : <h3>{__.roi.toFixed(4)}</h3>}
                                    </Col>
                                </Col>
                            ))
                        }
                        </Col>
                    <hr style={{width: "100%", backgroundColor: "#f7f7f7"}} />
                </div>
            </AntList.Item>
        );
    }

    renderHeader = () => {
        return (
            <div className={"d-flex m-5 flex-row justify-content-space-between align-items-center"}>
                <h4>Total Scheme - {this.props.schemeDetails.size} </h4>
                {this.props.schemeEditPermission ? (
                    <Button onClick={this.toggleModal} type="primary">Add New Scheme</Button>
                ) : null}
            </div>
        );
    }

    renderFeeHeader = () => {
        return (
            <div className={"d-flex m-5 pt-10 mt-10 mb-10 flex-row justify-content-space-between align-items-center"}>
                <h4>Fee Programs - {this.props.feeData.size}</h4>
                {this.props.schemeEditPermission ? (
                    <Button onClick={this.toggleFeeModal} type="primary">Add New Fee Program</Button>
                ) : null}
            </div>
        );
    }

    onSubmit = formData => {
        let finalData = this.props.schemeDetails;
        finalData = finalData.filter(_ => _.id !== formData.id).toJS();
        finalData = new List(finalData.map(_ => ({
            ..._,
            subvention_perc: _.subvention_perc !== "" ? _.subvention_perc : null,
            channel_product: _.channel_product && _.channel_product.map(__ => __.id),
            product: _.product && _.product.id,
            region: _.region && _.region.map(__ => __.id),
            lending_partner: _.lending_partner && _.lending_partner.id
        })));
        finalData = finalData.merge(formData);
        this.props.updateCompanyLosSchemes(this.props.companyId, finalData);
        this.setState({
            loading: true,
            visible: false,
        });
    }

    onFeeSubmit = formData => {
        this.props.fetchAddFee(this.props.companyId, formData);
        this.setState({
            feeLoading: true,
            loading: true
        });
    }
    onBounceChargeSubmit = (payload) => {
        CompanyLosService.addBounceCharge(this.props.companyId , payload)
        .then((resp => {
            this.toggleBounceChargeModal();
            this.props.fetchBounceCharges(this.props.companyId);
            message.success("Bounce Charge added successfully");
        }))
        .catch((err) => {
            message.error(err.non_field_errors ? err.non_field_errors[0] : "Something went wrong!")
            this.toggleBounceChargeModal();
        })
    }

    onPrePaymentSubmit = (formData) => {
        CompanyLosService.addPrePaymentCharge(this.props.companyId , formData)
        .then((resp => {
            this.togglePrePaymentChargeModal();
            this.props.fetchPrePaymentCharges(this.props.companyId);
            message.success("Pre Payment Charge added successfully");

        }))
        .catch((err) => {
            message.error(err.non_field_errors ? err.non_field_errors[0] : "Something went wrong!")
            this.togglePrePaymentChargeModal();
        })
    }

    onModalConfirm = () => {
        this.setState({
            schemeMigrating: true,
            confirmationModalShow: false
        }, () => {
            CompanyService.migrateScheme(this.props.companyId).then(({ data }) => {
                if (data && data.length) {
                    this.setState({
                        schemeMigrating: false
                    });
                    data.map(_ => {
                        if (_ && _.status === "success") {
                            notification.success({
                                message: `${_.scheme_name} - Scheme Migration Complete`,
                                description:
                                    _.message || "Scheme details for the company have been moved to LMS"
                            });
                            return;
                        } else {
                            notification.error({
                                message: `${_.scheme_name} - Scheme Migration Error`,
                                description:
                                    _.message || "Scheme details for the company cannot not be moved at this point. Please try again after sometime.",
                            });
                        }
                    });
                }
            }).catch(() => {
                this.setState({
                    schemeMigrating: false
                });
                notification.error({
                    message: "Scheme Migration Error",
                    description:
                        "Scheme details for the company cannot not be moved at this point. Please try again after sometime.",
                });
            });
        });

    }

    onModalCancel = () => {
        this.setState({
            confirmationModalShow: false
        });
    }

    migrateScheme = () => {
        this.setState({
            confirmationModalShow: true
        });
    }

    collapseOpenClose(key) {
        console.log("404qw3", key);
    }

    renderNewSchemeDetails() {
        return (
            <div className={"d-flex m-5 flex-row justify-content-space-between align-items-center"}>
                <div className={"scheme-section-one"}>
                    <h3>
                        Margin:
                    </h3>
                    <p>

                    </p>
                </div>
            </div>
        );
    }

    getAddCommonSchemeBtn() {
        return (
            <CheckActionPermission component={<React.Fragment>
                <a onClick={(event) => this.setState({ openAddCommoneSchemeBtn: true, clearFormState: false, isLendingScheme: false, isDefaultScheme: false }, event.stopPropagation())}>+ Add Common Scheme</a>
            </React.Fragment>} permission={this.props.schemeActionPermissions} />
        );
    }
    getAddCepSchemeBtn() {
        return (
            <CheckActionPermission component={<React.Fragment>
                <a onClick={(event) => this.setState({ openAddCepSchemeBtn: true, clearFormState: false, isLendingScheme: false, isDefaultScheme: false }, event.stopPropagation())}>+ Add CEP Scheme</a>
            </React.Fragment>} permission={this.props.schemeActionPermissions} />
        );
    }
    
    getAddCombinationalSchemeBtn() {
        return (
            <CheckActionPermission component={<React.Fragment>
                <a onClick={(event) => this.setState({ openAddCombinationalSchemeBtn: true, clearFormState: false, isLendingScheme: false, isDefaultScheme: false }, event.stopPropagation())}>+ Add Combinational Scheme</a>
            </React.Fragment>} permission={this.props.schemeActionPermissions} />
        );
    }

    getAddSubventionSchemeBtn() {
        return (
            <CheckActionPermission component={<React.Fragment>
                <a onClick={(event) => this.setState({ openAddSubventionSchemeBtn: true, clearFormState: false, isLendingScheme: false, isDefaultScheme: false }, event.stopPropagation())}>+ Add Per Unit Subvention Scheme</a>
            </React.Fragment>} permission={this.props.schemeActionPermissions} />
        );
    }

    getAddVendorFinanceSchemeBtn() {
        return (
            <CheckActionPermission component={<React.Fragment>
                <a onClick={(event) => this.setState({ openVendorFinanceSchemeBtn: true, clearFormState: false, isLendingScheme: false, isDefaultScheme: false }, event.stopPropagation())}>
                    + Add Vendor Finance Scheme
                </a>
            </React.Fragment>} permission={this.props.schemeActionPermissions} />
        );
    }
    
    getAddCommonCashCardSchemeBtn() {
        return (
            <CheckActionPermission component={<React.Fragment>
                <a onClick={(event) => this.setState({ openAddCashCard: true, clearFormState: false, isLendingScheme: false, isDefaultScheme: false }, event.stopPropagation())}>+ Add Cash Card Scheme</a>
            </React.Fragment>} permission={this.props.schemeActionPermissions} />
        );
    }

    getAddCommonTermLoanSchemeBtn() {
        return (
            <CheckActionPermission component={<React.Fragment>
                <a onClick={(event) => this.setState({ openAddTermLoanSchemeBtn: true, clearFormState: false, isLendingScheme: false, isDefaultScheme: false }, event.stopPropagation())}>+ Add Term Loan Scheme</a>
            </React.Fragment>} permission={this.props.schemeActionPermissions} />
        );
    }

    getAddCommonLenderBtn(){
        return (
            <CheckActionPermission component = {< React.Fragment >
                <a onClick={(event) => this.setState({ openAddCommoneSchemeBtn: true, clearFormState: false, isLendingScheme: true, isDefaultScheme: false }, event.stopPropagation())}>+ Add Lender Scheme</a>
            </React.Fragment >} permission = { this.props.schemeActionPermissions } />
        );
    }

    closedwSpDefaultEditModal() {
        this.setState({
            show_default_disbursal_wait_days: null,
            show_default_subvention_days: null,
            show_default_subvention_perc: null,
            dwSpDefaultEditModal: false,
            margin: null,
            show_api_err: false,
            non_field_error: null,
            showDefaultConfirm: false,
            editLoading: false,
            swd_readOnly: false,
            currentSchemeData: null
        });
    }

    closedwSpEditModal(){
        this.setState({
            dwSpEditModal: false,
            margin: null,
            show_api_err: false,
            non_field_error: null,
            editLoading: false,
            swd_readOnly: false,
            currentSchemeData: null
        });
    }

    onSubmitDefaultSp(){
        const data = {
            "disbursal_wait_days": this.state.default_disbursal_wait_days,
            "subvention_perc": this.state.default_subvention_perc,
            "subvention_days": this.state.default_subvention_days
        };
        this.setState({
            editLoading: true,
            show_api_err: false
        });
        CompanyService.submitDefaultSchemeList(this.props.companyId, this.state.schemeId, data).then(({ resData }) => {
            console.log(resData);
            message.success("Scheme updated!");
            this.setState({
                editLoading: false,
                dwSpDefaultEditModal: false,
                showDefaultConfirm: false,
                currentSchemeData: null
            });
            this.props.fetchCompanyLosSchemes(this.props.companyId);
        }).catch((err) => {
            // let key = Object.keys(err)[0];
            message.error("Failed to execute. Please try after sometime");
            this.setState({
                show_api_err: true,
                non_field_error: err.non_field_errors && err?.non_field_errors.length && err?.non_field_errors[0] || err[Object.keys(err)]  && err[Object.keys(err)][0] || "Please enter correct data",
                editLoading: false
            });
            // this.props.fetchCompanyLosSchemes(this.props.companyId);
        });
    }
  
    onAddSubventionScheme(){
        const data = {
            "disbursal_wait_days": this.state.disbursal_wait_days,
            "subvention_days": this.state.subvention_days,
            "subvention_per_unit": this.state.subvention_per_unit
        };
        this.setState({
            editLoading: true,
            show_api_err: false
        });
        CompanyService.submitDefaultSchemeList(this.props.companyId, this.state.schemeId, data).then(({ resData }) => {
            message.success("Scheme updated!");
            this.setState({
                editLoading: false,
                showDefaultConfirm: false,
                addSubventionScheme: false,
                disbursal_wait_days: null,
                subvention_days: null,
                subvention_per_unit: null
            });
            this.props.fetchCompanyLosSchemes(this.props.companyId);
        }).catch((err) => {
            message.error("Failed to execute. Please try after sometime");
            this.setState({
                show_api_err: true,
                non_field_error: err.non_field_errors && err?.non_field_errors.length && err?.non_field_errors[0] || err[Object.keys(err)]  && err[Object.keys(err)][0] || "Please enter correct data",
                editLoading: false,
                addSubventionScheme: false,
                disbursal_wait_days: null,
                subvention_days: null,
                subvention_per_unit: null
            });
        });
    }

    onSubmitSp(){
        const data = [{
            "disbursal_wait_days": this.state.disbursal_wait_days,
            "subvention_perc": this.state.subvention_perc,
            "subvention_days": this.state.subvention_days
        }];
        this.setState({
            editLoading: true,
            show_api_err: false
        });
        CompanyService.submitSchemeList(this.props.companyId, this.state.schemeId, data).then(({ resData }) => {
            console.log(resData);
            message.success("Scheme updated!");
            this.setState({
                dwSpEditModal: false,
                editLoading: false,
                currentSchemeData: null
            });
            this.props.fetchCompanyLosSchemes(this.props.companyId);
        }).catch((err) => {
            // let key = Object.keys(err)[0];
            message.error("Failed to execute. Please try after sometime");
            this.setState({
                show_api_err: true,
                non_field_error: err.non_field_errors && err?.non_field_errors.length && err?.non_field_errors[0] || err[Object.keys(err)]?.length && err[Object.keys(err)][0] || "Please enter correct data",
                editLoading: false,
                currentSchemeData: null
            });
            // this.props.fetchCompanyLosSchemes(this.props.companyId);
        });
    }

    onSubmitSubventionScheme(){
        const data = {
            "disbursal_wait_days": this.state.disbursal_wait_days,
            "subvention_days": this.state.subvention_days,
            "subvention_per_unit": this.state.subvention_per_unit
        };
        this.setState({
            editLoading: true,
            show_api_err: false
        });
        CompanyService.submitDefaultSchemeList(this.props.companyId, this.state.schemeId, data).then(({ resData }) => {
            console.log(resData);
            message.success("Scheme updated!");
            this.setState({
                dwSpEditModal: false,
                editLoading: false,
                openModalSubventionScheme: false,
                disbursal_wait_days: null,
                subvention_days: null,
                subvention_per_unit: null
            });
            this.props.fetchCompanyLosSchemes(this.props.companyId);
        }).catch((err) => {
            message.error("Failed to execute. Please try after sometime");
            this.setState({
                show_api_err: true,
                non_field_error: err.non_field_errors && err?.non_field_errors.length && err?.non_field_errors[0] || err[Object.keys(err)]?.length && err[Object.keys(err)][0] || "Please enter correct data",
                editLoading: false,
                openModalSubventionScheme: false,
                disbursal_wait_days: null,
                subvention_days: null,
                subvention_per_unit: null
            });
        });
    }

    clearCommonSchemeDetail(){
        this.setState({
            isDefaultScheme: false,
            clearFormState: true,
            openAddCommoneSchemeBtn: false,
            openAddSubventionSchemeBtn: false,
            getAddVendorFinanceSchemeBtn: false,
            openAddCombinationalSchemeBtn: false,
            openAddTermLoanSchemeBtn: false,
            openAddCepSchemeBtn: false
        });
    }

    clearCashCardDetail(){
        this.setState({
            openAddCashCard: false,
            clearFormState: true,
            isDefaultScheme: false
        });
    }

    setDefaultSubventionPercDay(e){
        if(e < 0 || e > 100){
            this.setState({
                errMsg: "Value can't be less than 0 or greater than 100",
                showSPError: true
            });
        }else{
            const subvention_days = this.state.default_normalRoi != 0  ? Math.floor((e / ((this.state.sellerRoi ? this.state.sellerRoi :  this.state.default_normalRoi) / 365)).toFixed(2)) : 0;
            this.setState({ 
                default_subvention_perc: e, 
                default_subvention_days: this.state.currentSchemeData != null && [1,2,3].includes(this.state.currentSchemeData.get('scheme_type')) ? null :  subvention_days,
                showSPError: false,
                errMsg: null
            });
        }
    }

    setSubventionPercDay(e){
        if(e < 0 || e > 100){
            this.setState({
                errMsg: "Value can't be less than 0 or greater than 100",
                showSPError: true
            });
        }else{
            const subvention_days = this.state.default_normalRoi == 0 ? 0 :   Math.floor((e / ((this.state.sellerRoi ? this.state.sellerRoi :  this.state.default_normalRoi) / 365)).toFixed(2));
            this.setState({ 
                subvention_perc: e, 
                subvention_days: this.state.currentSchemeData != null && [1,2,3].includes(this.state.currentSchemeData.get('scheme_type')) ? null : subvention_days,
                showSPError: false,
                errMsg: null
            });
        }
    }

    onCreateSuccess(){
        this.setState({
            loading: true,
            openAddCommoneSchemeBtn: false,
            openAddCashCard: false,
            openAddCombinationalSchemeBtn: false,
            openAddTermLoanSchemeBtn: false,
            openAddSubventionSchemeBtn: false,
            getAddVendorFinanceSchemeBtn: false,
            openAddCepSchemeBtn: false
        });
        this.props.fetchCompanyLosSchemes(this.props.companyId);
    }

    fieldCheck = (item, value) =>{
        console.log("dawedacheck", item);
        if(value){
            if(value < 0 || value > this.state.overdueTenor ){
                this.setState({
                    showDWDError: true,
                    errMsg: "Value can't be greater than tenor day."
                });
            }else{
                this.setState({
                    showDWDError: false,
                    errMsg: null
                });
            }
        }
    }

    focusOutEvent=(stateName, errorName)=>{
        if ((stateName == 'subvention_perc' || stateName == 'default_subvention_perc') && [1, 2, 3, 11].includes(this.state.currentSchemeData.get('scheme_type'))) {
            const roi_schedule = this.state.currentSchemeData.get('normal_roi_schedule');
            let json = {'subvention_perc': this.state[stateName]};
            for (let i = 0; i <= 2; i++) {
                if (i <= roi_schedule.length) {
                    const data = roi_schedule[i];
                    json[`roi_schedule${i}from_days`] = data ? data['from_days'] || "" : "";
                    json[`roi_schedule${i}to_days`] = data ? data['to_days'] || "" : "";
                    json[`roi_schedule${i}roi`] = data ? data['roi'] || "" : "";
                }
                else {
                    break;
                }
            }
            
            CompanyLosService.getSubventionPercentage(json)
                .then((resp) => {
                    this.setState({
                        subvention_days: resp.data.subvention_days,
                        default_subvention_days : resp.data.subvention_days
                    });
                })
                .catch((err) => {
                    console.error("Error fetching subvention percentage:", err);
                });
        }
        if(this.state[errorName]){
            this.setState({
                [stateName]: null,
                [errorName]: false
            });
        }else{
            this.setState({
                [errorName]: false
            });
        }
    }

    checkDefaultSubmit=()=>{
        const {swd_readOnly, default_disbursal_wait_days, default_subvention_perc} = this.state;
        if(swd_readOnly){
            if(!default_disbursal_wait_days || default_subvention_perc == null){
                return true;
            }else{
                return false;
            }
        }else{
            if(!default_disbursal_wait_days || default_subvention_perc == null){
                return true;
            }else{
                return false;
            }
        }
    }

    checkSubmit=()=>{
        const {disbursal_wait_days, swd_readOnly, subvention_perc} = this.state;
        if(swd_readOnly){
            if(!disbursal_wait_days || subvention_perc == null){
                return true;
            }else{
                return false;
            }
        }else{
            if(!disbursal_wait_days || subvention_perc == null){
                return true;
            }else{
                return false;
            }
        }
    }

    handleConfirmCancel(){
        this.setState({
            schemeId: null,
            showConfirmModal: false
        });
    }

    renderPrePaymentCharges = (_, key) => {
        return <AntList.Item
        key={key}
        className={
            "border-none flex-column padless-card mt-10 schemes-detail bg-white align-items-start"
        }
    >
        <div className={"p-5 w-100"}>
            <h3 className="mb-10 p-5">{_.foreclosure_master.name}</h3>
            {_.foreclosure_master.configuration.map((__, key) =>
                <Row style={{ borderBottom: "0.2px solid rgba(0, 0, 0, 0.4)" }} className={"m-10 pb-5"} key={key}>
                    <Col span={7}>
                        <Statistic
                            valueStyle={{
                                fontSize: "16px",
                                fontWeight: 600
                            }}
                            title={"From Tenure"}
                            value={__.from_tenure}
                        />
                    </Col>
                    <Col span={7}>
                        <Statistic
                            valueStyle={{
                                fontSize: "16px",
                                fontWeight: 600
                            }}
                            title={"To Tenure"}
                            value={__.to_tenure}
                        />
                    </Col>
                    <Col span={7}>
                        <Statistic
                            valueStyle={{
                                fontSize: "16px",
                                fontWeight: 600
                            }}
                            title={"Charge"}
                            value={__.value}
                        />
                    </Col>
                </Row>)}
        </div>
    </AntList.Item>
    }

    render() {
        if (this.props.schemeDetailsStatus !== STATE_STATUS.FETCHED && this.props.schemeDetailsStatus !== STATE_STATUS.UPDATED) {
            return (
                <Spin className={"d-flex justify-content-center p-10"} />
            );
        }
        const schemeData = this.props.schemeDetails.filter(_ => _.lending_partner == null && [1, 9].includes(_.scheme_type)).toJS();
        const cepSchemeData = this.props.schemeDetails.filter(_ => _.lending_partner == null && [11].includes(_.scheme_type)).toJS();
        const cashCardSchemeData = this.props.schemeDetails.filter(_ => _.lending_partner == null && _.scheme_type == 2).toJS();
        const combinationalSchemeData = this.props.schemeDetails.filter(_ => _.lending_partner == null && _.scheme_type == 3).toJS();
        const termLoanSchemeData = this.props.schemeDetails.filter(_ => _.lending_partner == null && _.scheme_type == 4).toJS();
        const isDefaultExist = this.props.schemeDetails.filter(_ => _.lending_partner == null && _.is_default_scheme == true).toJS();
        const perUnitSubventionSchemeData = this.props.schemeDetails.filter(_ => _.lending_partner == null && _.scheme_type == 7).toJS();
        const vendorFinanceSchemeData = this.props.schemeDetails.filter(_ => _.lending_partner == null && _.scheme_type == 8).toJS();
        return (
            <Row>
                <Modal title="Confirm" visible={this.state.showConfirmModal} onCancel={() => this.handleConfirmCancel()}
                    footer={[
                        <Button key="submit" type="primary" loading={this.state.confirmLoading} onClick={() => this.onConfirmSubmit()}>
                            Yes
                        </Button>,
                        <Button key="back" onClick={() => this.handleConfirmCancel()}>
                            No
                        </Button>
                    ]}>
                    This scheme will now be applicable for the new cases logged in. Are you sure?
                </Modal>
                <Modal 
                    width={800} 
                    title={"Add Scheme"} 
                    visible={this.state.openAddCommoneSchemeBtn} 
                    onCancel={() => this.clearCommonSchemeDetail()} 
                    footer={null}
                >
                    <AddCommonSchemeDetail 
                        anchorList={this.state.anchorList}
                        companyId={this.props.companyId} 
                        isDefaultScheme={this.state.isDefaultScheme}
                        isLendingScheme={this.state.isLendingScheme}
                        clearState={this.state.clearFormState}
                        stateCleared={() => this.setState({clearFormState: false})}
                        partnerbank={this.state.partnerbank_data}
                        onSuccess={() => this.onCreateSuccess()}
                        schemeTypeData={"1"}
                        schemeType={"1"}
                        isRoiPermission={this.props.roi_permissions}
                    />
                </Modal>
                <Modal 
                    width={800} 
                    title={"Add Scheme"} 
                    visible={this.state.openAddCepSchemeBtn} 
                    onCancel={() => this.clearCommonSchemeDetail()} 
                    footer={null}
                >
                    <AddCepSchemeForm 
                        anchorList={this.state.anchorList}
                        companyId={this.props.companyId} 
                        isDefaultScheme={this.state.isDefaultScheme}
                        isLendingScheme={this.state.isLendingScheme}
                        clearState={this.state.clearFormState}
                        stateCleared={() => this.setState({clearFormState: false})}
                        partnerbank={this.state.partnerbank_data}
                        onSuccess={() => this.onCreateSuccess()}
                        schemeTypeData={"11"}
                        schemeType={"11"}
                        isRoiPermission={this.props.roi_permissions}
                    />
                </Modal>
                <Modal 
                    width={800} 
                    title={"Add Scheme"} 
                    visible={this.state.openAddCashCard} 
                    onCancel={() => this.clearCashCardDetail()} 
                    footer={null}
                >
                    <AddCashCardForm 
                        anchorList={this.state.anchorList}
                        companyId={this.props.companyId} 
                        isDefaultScheme={this.state.isDefaultScheme}
                        isLendingScheme={this.state.isLendingScheme}
                        clearState={this.state.clearFormState}
                        stateCleared={() => this.setState({clearFormState: false})}
                        partnerbank={this.state.partnerbank_data}
                        onSuccess={() => this.onCreateSuccess()}
                        schemeType={"2"}
                    />
                </Modal>
                <Modal 
                    width={800} 
                    title={"Add Scheme"} 
                    visible={this.state.openAddCombinationalSchemeBtn} 
                    onCancel={() => this.clearCommonSchemeDetail()} 
                    footer={null}
                >
                    <AddCombinationalSchemeDetail 
                        anchorList={this.state.anchorList}
                        companyId={this.props.companyId} 
                        isDefaultScheme={this.state.isDefaultScheme}
                        isLendingScheme={this.state.isLendingScheme}
                        clearState={this.state.clearFormState}
                        stateCleared={() => this.setState({clearFormState: false})}
                        partnerbank={this.state.partnerbank_data}
                        onSuccess={() => this.onCreateSuccess()}
                        schemeTypeData={"3"}
                        schemeType={"3"}
                    />
                </Modal>
                <Modal 
                    width={800} 
                    title={"Add Scheme"} 
                    visible={this.state.openAddSubventionSchemeBtn} 
                    onCancel={() => this.clearCommonSchemeDetail()} 
                    footer={null}
                >
                    <AddSubventionSchemeDetail 
                        anchorList={this.state.anchorList}
                        companyId={this.props.companyId} 
                        isDefaultScheme={this.state.isDefaultScheme}
                        isLendingScheme={this.state.isLendingScheme}
                        clearState={this.state.clearFormState}
                        stateCleared={() => this.setState({clearFormState: false})}
                        partnerbank={this.state.partnerbank_data}
                        onSuccess={() => this.onCreateSuccess()}
                        schemeTypeData={"6"}
                        schemeType={"6"}
                    />
                </Modal>
                <Modal 
                    width={900} 
                    title={"Add Scheme"} 
                    visible={this.state.openAddTermLoanSchemeBtn} 
                    onCancel={() => this.clearCommonSchemeDetail()} 
                    footer={null}
                >
                    <AddTermLoanSchemeDetail 
                        anchorList={this.state.anchorList}
                        companyId={this.props.companyId} 
                        isDefaultScheme={this.state.isDefaultScheme}
                        isLendingScheme={this.state.isLendingScheme}
                        clearState={this.state.clearFormState}
                        stateCleared={() => this.setState({clearFormState: false})}
                        partnerbank={this.state.partnerbank_data}
                        onSuccess={() => this.onCreateSuccess()}
                        schemeTypeData={"3"}
                        schemeType={"3"}
                    />
                </Modal>
                <Modal
                    width={800}
                    title={"Add Scheme"}
                    visible={this.state.getAddVendorFinanceSchemeBtn}
                    onCancel={() => this.clearCommonSchemeDetail()}
                    footer={null}
                >
                    <AddCommonSchemeDetail
                        anchorList={this.state.anchorList}
                        companyId={this.props.companyId}
                        isDefaultScheme={this.state.isDefaultScheme}
                        isLendingScheme={this.state.isLendingScheme}
                        clearState={this.state.clearFormState}
                        stateCleared={() => this.setState({clearFormState: false})}
                        partnerbank={this.state.partnerbank_data}
                        onSuccess={() => this.onCreateSuccess()}
                        schemeTypeData={"8"}
                        schemeType={"8"}
                        isRoiPermission={this.props.roi_permissions}
                    />
                </Modal>
                <Modal visible={this.state.dwSpDefaultEditModal} footer={null} onCancel={() => this.closedwSpDefaultEditModal()}>
                    <p style={{ fontWeight: "bold" }}>Disbursal wait Days:</p>
                    <Input onBlur={() => this.focusOutEvent("default_disbursal_wait_days", "showDWDError")} type={number} onChange={(e) => this.setState({ default_disbursal_wait_days: e.target.value }, this.fieldCheck("Disbursal wait Days", e.target.value))} value={this.state.default_disbursal_wait_days} />
                    {this.state.showDWDError && <span style={{fontSize: "11px", color: "red"}}>{this.state.errMsg}</span>}
                    <br />
                    <p style={{ fontWeight: "bold" }} className={"mt-10"}>Subvention %:</p>
                    <InputNumber className={this.state.swd_readOnly?"read-only-input":""} readOnly={this.state.swd_readOnly} onBlur={() => this.focusOutEvent("default_subvention_perc", "showSPError")} style={{ width: "100%" }} precision={2} onChange={(e) => this.setDefaultSubventionPercDay(e)} value={this.state.default_subvention_perc} />
                    {this.state.swd_readOnly && <span style={{fontSize: "11px", color: "black"}}>Subvention % can not be more than 0 as cash-back is not applicable for this scheme</span>}
                    {this.state.showSPError && <span style={{fontSize: "11px", color: "red"}}>{this.state.errMsg}</span>}
                    <p style={{ fontWeight: "bold" }} className={"mt-10"}>Subvention Days:</p>

                    <Input className={"read-only-input"} type={number} value={this.state.default_subvention_days} readOnly={!this.state.isFlexible} />

                    {!this.state.showDefaultConfirm && <Button style={{marginTop: "20px"}} onClick={() => this.setState({showDefaultConfirm: true})} loading={this.state.editLoading} disabled={this.checkDefaultSubmit()} className={"ant-btn ant-btn-primary"}>Submit</Button>}

                    {
                        this.state.showDefaultConfirm && <Row style={{marginTop: "20px"}}>
                            <p style={{color: "red", fontWeight: "bold"}}>This will update the parameters from DWD: {this.state.show_default_disbursal_wait_days} | Subvention: {this.state.show_default_subvention_perc} %, {this.state.show_default_subvention_days} days to DWD: {this.state.default_disbursal_wait_days} | Subvention: {this.state.default_subvention_perc} %, {this.state.default_subvention_days} days for all cases under this seller.</p>
                            <p style={{color: "red", fontWeight: "bold"}}>Are you sure?</p>
                            <Col>
                                {
                                    this.state.show_api_err?<Col className={"m-5"}>
                                        <span className={"error-text"}>* {this.state.non_field_error}</span>
                                    </Col>:null
                                }
                                <Button style={{ marginTop: "20px" }} onClick={() => this.onSubmitDefaultSp()} loading={this.state.editLoading} className={"ant-btn ant-btn-primary"}>Yes</Button>
                                <Button style={{ marginTop: "20px", marginLeft: "20px" }} onClick={() => this.setState({showDefaultConfirm: false})} className={"ant-btn ant-btn-primary"}>No</Button>
                            </Col>
                        </Row>
                    }
                </Modal>
                <Modal visible={this.state.dwSpEditModal} footer={null} onCancel={() => this.closedwSpEditModal()}>
                    <p style={{ fontWeight: "bold" }}>Disbursal wait Days:</p>
                    <Input onBlur={() => this.focusOutEvent("disbursal_wait_days", "showDWDError")} type={number} onChange={(e) => this.setState({ disbursal_wait_days: e.target.value }, this.fieldCheck("Disbursal wait Days", e.target.value))} value={this.state.disbursal_wait_days} />
                    {this.state.showDWDError && <span style={{fontSize: "11px", color: "red"}}>{this.state.errMsg}</span>}
                    <br />
                    <p style={{ fontWeight: "bold" }} className={"mt-10"}>Subvention %:</p>
                    <InputNumber className={this.state.swd_readOnly?"read-only-input":""} readOnly={this.state.swd_readOnly} onBlur={() => this.focusOutEvent("subvention_perc", "showSPError")} style={{ width: "100%" }} precision={2} type={number} onChange={(e) => this.setSubventionPercDay(e)} value={this.state.subvention_perc} />
                    {this.state.swd_readOnly && <span style={{fontSize: "11px", color: "black"}}>Subvention % can not be more than 0 as cash-back is not applicable for this scheme</span>}
                    {this.state.showSPError && <span style={{fontSize: "11px", color: "red"}}>{this.state.errMsg}</span>}
                    <p style={{ fontWeight: "bold" }} className={"mt-10"}>Subvention Days:</p>

                    <Input className={"read-only-input"} type={number} value={this.state.subvention_days} readOnly={!this.state.isFlexible} />

                    {
                        this.state.show_api_err?<Col className={"m-5"}>
                            <span className={"error-text"}>* {this.state.non_field_error}</span>
                        </Col>:null
                    }
                    <Button style={{marginTop: "20px"}} onClick={() => this.onSubmitSp()} loading={this.state.editLoading} 
                        disabled={this.checkSubmit()}
                        className={"ant-btn ant-btn-primary"}>Submit</Button>
                </Modal>
                <Modal visible={this.state.addSubventionScheme} footer={null} onCancel={() => this.setState({addSubventionScheme: false})}>
                    <p style={{ fontWeight: "bold" }}>Disbursal wait Days:</p>
                    <Input type={number} onChange={(e) => this.setState({ disbursal_wait_days: e.target.value })} value={this.state.disbursal_wait_days} />
                    <br />
                    <p style={{ fontWeight: "bold" }} className={"mt-10"}>Subvention Days:</p>
                    <Input type={number} onChange={(e) => this.setState({ subvention_days: e.target.value })} value={this.state.subvention_days}/>
                    <br />
                    <p style={{ fontWeight: "bold" }} className={"mt-10"}>Subvention Amount Per Unit:</p>
                    <Input type={number} onChange={(e) => this.setState({ subvention_per_unit: e.target.value })} value={this.state.subvention_per_unit}/>
                    {
                        this.state.show_api_err?<Col className={"m-5"}>
                            <span className={"error-text"}>* {this.state.non_field_error}</span>
                        </Col>:null
                    }
                    <Button style={{marginTop: "20px"}} onClick={() => this.onAddSubventionScheme()} loading={this.state.editLoading}
                        className={"ant-btn ant-btn-primary"}>Submit</Button>
                </Modal>
                <Modal visible={this.state.openModalSubventionScheme} footer={null} onCancel={() => this.setState({openModalSubventionScheme:false})}>
                    <p style={{ fontWeight: "bold" }}>Disbursal wait Days:</p>
                    <Input type={number} onChange={(e) => this.setState({ disbursal_wait_days: e.target.value }, this.fieldCheck("Disbursal wait Days", e.target.value))} value={this.state.disbursal_wait_days} />
                    <br />
                    <p style={{ fontWeight: "bold" }} className={"mt-10"}>Subvention Days:</p>
                    <Input type={number} onChange={(e) => this.setState({ subvention_days: e.target.value }, this.fieldCheck("Subvention Days", e.target.value))} value={this.state.subvention_days}/>
                    <br />
                    <p style={{ fontWeight: "bold" }} className={"mt-10"}>Subvention Amount Per Unit</p>
                    <Input type={number} value={this.state.subvention_per_unit} onChange={(e) => this.setState({ subvention_per_unit: e.target.value }, this.fieldCheck("Subvention Amount Per Unit", e.target.value))}  />
                    <Button style={{marginTop: "20px"}} onClick={() => this.setState({showDefaultConfirm: true})} loading={this.state.editLoading} 
                        className={"ant-btn ant-btn-primary"}>Submit</Button>
                    {
                        this.state.showDefaultConfirm && this.state.anchorUnit && this.state.minNormalRoi && this.state.maxNormalRoi && <Row style={{marginTop: "20px"}}>
                            <p style={{color: "red", fontWeight: "bold"}}>As per above parameters, price of {this.state.anchorUnit} can vary from {(((365*this.state.subvention_per_unit)/(this.state.minNormalRoi * this.state.subvention_days))*100).toFixed(2)} to {(((365*this.state.subvention_per_unit)/(this.state.maxNormalRoi * this.state.subvention_days))*100).toFixed(2)}</p>
                            <p style={{color: "red", fontWeight: "bold"}}>Are you sure?</p>
                            <Col>
                                {
                                    this.state.show_api_err?<Col className={"m-5"}>
                                        <span className={"error-text"}>* {this.state.non_field_error}</span>
                                    </Col>:null
                                }
                                <Button style={{ marginTop: "20px" }} onClick={() => this.onSubmitSubventionScheme()} loading={this.state.editLoading} className={"ant-btn ant-btn-primary"}>Yes</Button>
                                <Button style={{ marginTop: "20px", marginLeft: "20px" }} onClick={() => this.setState({showDefaultConfirm: false})} className={"ant-btn ant-btn-primary"}>No</Button>
                            </Col>
                        </Row>
                    }
                </Modal>
                {
                    schemeData.length == 0 ? <Col offset={3} span={18} className={"d-flex"}>
                        <hr className="solid" />
                        {/* <Button
                        onClick={this.migrateScheme}
                        loading={this.state.schemeMigrating}
                        type="default"
                        disabled={!this.props.schemeDetails || this.props.schemeDetails.size === 0}
                    >
                        Migrate Scheme to LMS
                    </Button> */}
                        <Col span={18}>
                            <div className={"d-flex m-5 pt-10 mt-10 mb-10 flex-row justify-content-space-between align-items-center"}>
                                <h4>Common Schemes - 0</h4>
                            </div>
                        </Col>
                        <Col span={6} className={"d-flex flex-row-reverse m-5"} style={{paddingRight: "16px"}}>
                            <CheckActionPermission component={<Button
                                onClick={() => this.setState({ openAddCommoneSchemeBtn: true, isDefaultScheme: isDefaultExist.length !== 0 ? false:true })}
                                loading={this.state.schemeMigrating}
                                type="default"
                                style={{ background: "#345F77", color: "#ffffff" }}
                                className={"ant-btn"}
                            >
                                {isDefaultExist.length !== 0 ? "Add Scheme":"Add Default Scheme"}
                            </Button>} permission={this.props.schemeActionPermissions}/>
                        </Col>
                    </Col> : <Col offset={3} span={18} style={{ marginTop: "20px" }}>
                        <div className={"verticalScroll"}>
                            <Collapse collapsible={"header"} defaultActiveKey={["1", "2"]} onChange={(key) => this.collapseOpenClose(key)}>
                                <Panel header={"Common Schemes:" + schemeData.length} key="1" extra={this.getAddCommonSchemeBtn()}>
                                    <AntList
                                        border={false}
                                        className={"border-none"}
                                        footer={null}
                                        dataSource={this.props.schemeDetails.filter(_ => _.lending_partner == null && [1, 9].includes(_.scheme_type))}
                                        renderItem={(_ , key) => this.renderListItem(_ , key , true)}
                                    />
                                </Panel>
                                <Panel header={"Lender Schemes:" + this.props.schemeDetails.filter(_ => _.lending_partner !== null).size} key="2"> {/* //extra={this.getAddCommonLenderBtn()}> */}
                                    <div className={"d-flex m-5 flex-row justify-content-space-between align-items-center"}>
                                        <AntList
                                            border={false}
                                            className={"border-none"}
                                            footer={null}
                                            dataSource={this.props.schemeDetails.filter(_ => _.lending_partner !== null)}
                                            renderItem={this.renderListItem}
                                        />
                                    </div>
                                </Panel>
                            </Collapse>
                        </div>
                    </Col>
                }

                {
                    cepSchemeData.length == 0 ? <Col offset={3} span={18} className={"d-flex"}>
                        <hr className="solid" />
                        {/* <Button
                        onClick={this.migrateScheme}
                        loading={this.state.schemeMigrating}
                        type="default"
                        disabled={!this.props.schemeDetails || this.props.schemeDetails.size === 0}
                    >
                        Migrate Scheme to LMS
                    </Button> */}
                        <Col span={18}>
                            <div className={"d-flex m-5 pt-10 mt-10 mb-10 flex-row justify-content-space-between align-items-center"}>
                                <h4>Facotring Schemes - 0</h4>
                            </div>
                        </Col>
                        <Col span={6} className={"d-flex flex-row-reverse m-5"} style={{paddingRight: "16px"}}>
                            <CheckActionPermission component={<Button
                                onClick={() => this.setState({ openAddCepSchemeBtn: true, isDefaultScheme: isDefaultExist.length !== 0 ? false:true })}
                                loading={this.state.schemeMigrating}
                                type="default"
                                style={{ background: "#345F77", color: "#ffffff" }}
                                className={"ant-btn"}
                            >
                                {"Add CEP Scheme"}
                            </Button>} permission={this.props.schemeActionPermissions}/>
                        </Col>
                    </Col> : <Col offset={3} span={18} style={{ marginTop: "20px" }}>
                        <div className={"verticalScroll"}>
                            <Collapse collapsible={"header"} defaultActiveKey={["1", "2"]} onChange={(key) => this.collapseOpenClose(key)}>
                                <Panel header={"CEP Schemes:" + cepSchemeData.length} key="1" extra={this.getAddCepSchemeBtn()}>
                                    <AntList
                                        border={false}
                                        className={"border-none"}
                                        footer={null}
                                        dataSource={this.props.schemeDetails.filter(_ => _.lending_partner == null && _.scheme_type == 11)}
                                        renderItem={(_ , key) => this.renderListItem(_ , key , true)}
                                    />
                                </Panel>
                            </Collapse>
                        </div>
                    </Col>
                }

                {
                    this.props.companyDetails.toJS().type_of_scheme.includes(7) && <React.Fragment>
                        {
                            perUnitSubventionSchemeData.length == 0 ? <Col offset={3} span={18} className={"d-flex"}>
                                <Col span={18}>
                                    <div className={"d-flex m-5 pt-10 mt-10 mb-10 flex-row justify-content-space-between align-items-center"}>
                                        <h4>Per Unit Subvention Schemes - 0</h4>
                                    </div>
                                </Col>
                                <Col span={6} className={"d-flex flex-row-reverse m-5"} style={{ paddingRight: "16px" }}>
                                    <Button
                                        onClick={() => this.setState({ openAddSubventionSchemeBtn: true, isDefaultScheme: isDefaultExist.length !== 0 ?false:true })}
                                        loading={this.state.schemeMigrating}
                                        type="default"
                                        style={{ background: "#345F77", color: "#ffffff" }}
                                        className={"ant-btn"}
                                    >
                                        {isDefaultExist.length !== 0 ? "Add Per Unit Subvention Scheme":"Add Default Per Unit Subvention Scheme"}
                                    </Button>
                                </Col>
                            </Col> : <Col offset={3} span={18} style={{ marginTop: "20px" }}>
                                <div className={"verticalScroll"}>
                                    <Collapse collapsible={"header"} defaultActiveKey={["1", "2"]}  onChange={(key) => this.collapseOpenClose(key)}>
                                        <Panel header={"Per Unit Subvention Schemes:" + perUnitSubventionSchemeData.length} key="1" extra={this.getAddSubventionSchemeBtn()}>
                                            <AntList
                                                border={false}
                                                className={"border-none"}
                                                footer={null}
                                                dataSource={this.props.schemeDetails.filter(_ => _.lending_partner == null && _.scheme_type == 7)}
                                                renderItem={this.renderPerUnitSubventionItem}
                                            />
                                        </Panel>
                                    </Collapse>
                                </div>
                            </Col>
                        }
                    </React.Fragment>
                }
                {
                    this.props.companyDetails.toJS().type_of_scheme.includes(3) && <React.Fragment>
                        {
                            combinationalSchemeData.length == 0 ? <Col offset={3} span={18} className={"d-flex"}>
                                <Col span={18}>
                                    <div className={"d-flex m-5 pt-10 mt-10 mb-10 flex-row justify-content-space-between align-items-center"}>
                                        <h4>Combinational Schemes - 0</h4>
                                    </div>
                                </Col>
                                <Col span={6} className={"d-flex flex-row-reverse m-5"} style={{ paddingRight: "16px" }}>
                                    <Button
                                        onClick={() => this.setState({ openAddCombinationalSchemeBtn: true, isDefaultScheme: isDefaultExist.length !== 0 ?false:true })}
                                        loading={this.state.schemeMigrating}
                                        type="default"
                                        style={{ background: "#345F77", color: "#ffffff" }}
                                        className={"ant-btn"}
                                    >
                                        {isDefaultExist.length !== 0 ? "Add Combinational Scheme":"Add Default Combinational Scheme"}
                                    </Button>
                                </Col>
                            </Col> : <Col offset={3} span={18} style={{ marginTop: "20px" }}>
                                <div className={"verticalScroll"}>
                                    <Collapse collapsible={"header"} defaultActiveKey={["1", "2"]} onChange={(key) => this.collapseOpenClose(key)}>
                                        <Panel header={"Combinational Schemes:" + combinationalSchemeData.length} key="1" extra={this.getAddCombinationalSchemeBtn()}>
                                            <AntList
                                                border={false}
                                                className={"border-none"}
                                                footer={null}
                                                dataSource={this.props.schemeDetails.filter(_ => _.lending_partner == null && _.scheme_type == 3)}
                                                renderItem={this.renderCombinationalListItem}
                                            />
                                        </Panel>
                                    </Collapse>
                                </div>
                            </Col>
                        }
                    </React.Fragment>
                }
                {
                    this.props.companyDetails.toJS().type_of_scheme.includes(2) && <React.Fragment>
                        {
                            cashCardSchemeData.length == 0 ? <Col offset={3} span={18} className={"d-flex"}>
                                <Col span={18}>
                                    <div className={"d-flex m-5 pt-10 mt-10 mb-10 flex-row justify-content-space-between align-items-center"}>
                                        <h4>Cash Card Schemes - 0</h4>
                                    </div>
                                </Col>
                                <Col span={6} className={"d-flex flex-row-reverse m-5"} style={{ paddingRight: "16px" }}>
                                    <Button
                                        onClick={() => this.setState({ openAddCashCard: true, isDefaultScheme: isDefaultExist.length !== 0 ? false:true })}
                                        loading={this.state.schemeMigrating}
                                        type="default"
                                        style={{ background: "#345F77", color: "#ffffff" }}
                                        className={"ant-btn"}
                                    >
                                        {isDefaultExist.length !== 0 ? "Add Cash Card Scheme":"Add Default Cash Card Scheme"}
                                    </Button>
                                </Col>
                            </Col> : <Col offset={3} span={18} style={{ marginTop: "20px" }}>
                                <div className={"verticalScroll"}>
                                    <Collapse collapsible={"header"} defaultActiveKey={["1", "2"]} onChange={(key) => this.collapseOpenClose(key)}>
                                        <Panel header={"Cash Card Schemes:" + cashCardSchemeData.length} key="1" extra={this.getAddCommonCashCardSchemeBtn()}>
                                            <AntList
                                                border={false}
                                                className={"border-none"}
                                                footer={null}
                                                dataSource={this.props.schemeDetails.filter(_ => _.lending_partner == null && _.scheme_type == 2)}
                                                renderItem={this.renderCashCardListItem}
                                            />
                                        </Panel>
                                        <Panel header={"Lender Schemes:" + this.props.schemeDetails.filter(_ => _.lending_partner !== null).size} key="2"> {/* //extra={this.getAddCommonLenderBtn()}> */}
                                            <div className={"d-flex m-5 flex-row justify-content-space-between align-items-center"}>
                                                <AntList
                                                    border={false}
                                                    className={"border-none"}
                                                    footer={null}
                                                    dataSource={this.props.schemeDetails.filter(_ => _.lending_partner !== null)}
                                                    renderItem={this.renderListItem}
                                                />
                                            </div>
                                        </Panel>
                                    </Collapse>
                                </div>
                            </Col>
                        }
                    </React.Fragment>
                }
                {
                    this.props.companyDetails.toJS().type_of_scheme.includes(4) && 
                    <React.Fragment>
                        {
                            termLoanSchemeData.length == 0 ? <Col offset={3} span={18} className={"d-flex"}>
                                <Col span={18}>
                                    <div className={"d-flex m-5 pt-10 mt-10 mb-10 flex-row justify-content-space-between align-items-center"}>
                                        <h4>Term Loan Schemes - 0</h4>
                                    </div>
                                </Col>
                                <Col span={6} className={"d-flex flex-row-reverse m-5"} style={{ paddingRight: "16px" }}>
                                    <Button
                                        onClick={() => this.setState({ openAddTermLoanSchemeBtn: true, isDefaultScheme: isDefaultExist.length !== 0 ? false:true })}
                                        loading={this.state.schemeMigrating}
                                        type="default"
                                        style={{ background: "#345F77", color: "#ffffff" }}
                                        className={"ant-btn"}
                                    >
                                        {isDefaultExist.length !== 0 ? "Add Term Loan Scheme":"Add Default Term Loan Scheme"}
                                    </Button>
                                </Col>
                            </Col> : <Col offset={3} span={18} style={{ marginTop: "20px" }}>
                                <div className={"verticalScroll"}>
                                    <Collapse collapsible={"header"} defaultActiveKey={["1", "2"]}  onChange={(key) => this.collapseOpenClose(key)}>
                                        <Panel header={"Term Loan Schemes:" + termLoanSchemeData.length} key="1" extra={this.getAddCommonTermLoanSchemeBtn()}>
                                            <AntList
                                                border={false}
                                                className={"border-none"}
                                                footer={null}
                                                dataSource={this.props.schemeDetails.filter(_ => _.lending_partner == null && _.scheme_type == 4)}
                                                renderItem={this.renderTermLoan}
                                            />
                                        </Panel>
                                    </Collapse>
                                </div>
                            </Col>
                        }
                    </React.Fragment>
                }
                {
                   this.props.companyDetails.toJS().type_of_scheme.includes(8) ?
                    <Col offset={3} span={18} className={"d-flex"}>
                        <hr className="solid" />
                        <Col span={18}>
                            <div className={"d-flex m-5 pt-10 mt-10 mb-10 flex-row justify-content-space-between align-items-center"}>
                                <h4>Vendor Finance Scheme - {vendorFinanceSchemeData.length}</h4>
                            </div>
                        </Col>
                        <Col span={6} className={"d-flex flex-row-reverse m-5"} style={{paddingRight: "16px"}}>
                            <CheckActionPermission component={<Button
                                onClick={() => this.setState({ getAddVendorFinanceSchemeBtn: true, isDefaultScheme: isDefaultExist.length !== 0 ? false:true })}
                                loading={this.state.schemeMigrating}
                                type="default"
                                style={{ background: "#345F77", color: "#ffffff" }}
                                className={"ant-btn"}
                            >
                               Add Vendor Finance Scheme
                            </Button>} permission={this.props.schemeActionPermissions}/>
                        </Col>
                    </Col> : <></>
                }{this.props.companyDetails.toJS().type_of_scheme.includes(8) ? <Col offset={3} span={18} style={{ marginTop: "20px" }}>
                        <div className={"verticalScroll"}>
                            <Collapse collapsible={"header"} defaultActiveKey={["1", "2"]} onChange={(key) => this.collapseOpenClose(key)}>
                                <Panel header={"Vendor Finance Schemes:" + vendorFinanceSchemeData.length} key="1">
                                    <AntList
                                        border={false}
                                        className={"border-none"}
                                        footer={null}
                                        dataSource={this.props.schemeDetails.filter(_ => _.lending_partner == null && _.scheme_type == 8)}
                                        renderItem={(_ , key) => this.renderListItem(_ , key , true)}
                                    />
                                </Panel>
                          
                            </Collapse>
                        </div>
                    </Col> : <></>
                }
                <Col offset={3} span={18}>
                    <hr className="solid" />
                    {/* <div className={"verticalScroll"}>
                        <AntList
                            border={false}
                            className={"border-none"}
                            header={this.renderHeader()}
                            footer={null}
                            dataSource={this.props.schemeDetails}
                            renderItem={this.renderListItem}
                        />
                    </div> */}
                    {this.props.schemeEditPermission && this.state.visible && <CompanySchemeDetailsForm
                        loading={this.state.loading}
                        onValuesSubmit={this.onSubmit}
                        toggleModal={this.toggleModal}
                        values={new OrderedMap(this.props.schemeDetails.find(_ => this.state.currentId === _.id))}
                        visible={this.state.visible}
                    />}
                    {/* <div className={"verticalScroll"}>
                        <AntList
                            border={false}
                            className={"border-none"}
                            header={this.renderFeeHeader()}
                            footer={null}
                            dataSource={this.props.feeData}
                            renderItem={this.renderFeeListItem}
                        />
                    </div> */}
                    {this.props.schemeEditPermission && this.state.feeVisibile && <CompanyFeeForm
                        loading={this.state.feeLoading}
                        onValuesSubmit={this.onFeeSubmit}
                        toggleModal={this.toggleFeeModal}
                        feeMasterId={(this.props.feeData.find(_ => this.state.currentFeeId == _.id) && this.props.feeData.find(_ => this.state.currentFeeId == _.id).feeMasterId) || ""}
                        values={new OrderedMap((this.props.feeData.find(_ => this.state.currentFeeId == _.id) && this.props.feeData.find(_ => this.state.currentFeeId == _.id).feeFormData) || {})}
                        feeMaster={this.props.feeMaster}
                        visible={this.state.feeVisibile}
                        feeData={this.props.feeData.find(item => this.state.currentFeeId === item.id)}
                    />}


                    {this.props.schemeEditPermission && this.state.bouceChargeVisible && <CompanyBounceChargeForm
                        loading={this.state.feeLoading}
                        onValuesSubmit={this.onBounceChargeSubmit}
                        toggleModal={this.toggleBounceChargeModal}
                        bounceChargesMaster={this.props.bounceChargesListMaster.get("data")}
                        visible={this.state.bouceChargeVisible}
                        feeData={this.props.feeData.find(item => this.state.currentFeeId === item.id)}
                    />}

                    {this.props.schemeEditPermission && this.state.prePaymentChargeVisible && <CompanyPrePaymentChargeForm
                        loading={this.state.feeLoading}
                        onValuesSubmit={this.onPrePaymentSubmit}
                        toggleModal={this.togglePrePaymentChargeModal}
                        prePaymentChargesMaster={this.props.prePaymentChargesListMaster.get("data")}
                        visible={this.state.prePaymentChargeVisible}
                        feeData={this.props.feeData.find(item => this.state.currentFeeId === item.id)}
                    />}

                    <Card>

                        <Collapse
                            className="ant-d-collapse-padding custom-header-antd"
                            bordered={false}
                            expandIconPosition={"right"}
                        >
                            <Panel
                                header={
                                    <div className="displayInline">
                                        Fee Programs - {this.props.feeData.size}
                                    </div>
                                }
                                key="1" extra={this.props.schemeEditPermission ? (
                                    <Button onClick={this.toggleFeeModal} type="link">Add New Fee Program</Button>
                                ) : null}>
                                <div className={"verticalScroll"}>
                                    <AntList
                                        border={false}
                                        className={"border-none"}
                                        footer={null}
                                        dataSource={this.props.feeData}
                                        renderItem={this.renderFeeListItem}
                                    />
                                </div>
                            </Panel>
                            <Panel
                                header={
                                    <div className="displayInline">
                                        <div>Bounce Charges - {this.props.bounceChargesList && this.props.bounceChargesList.get('data').size}</div>

                                    </div>
                                }
                                key="2" extra={this.props.schemeEditPermission ? (
                                    <Button onClick={this.toggleBounceChargeModal} type="link">Add New Bounce Program</Button>
                                ) : null}>
                                <div className={"verticalScroll"}>
                                    <AntList
                                        border={false}
                                        className={"border-none"}
                                        footer={null}
                                        dataSource={this.props.bounceChargesList.get('data')}
                                        renderItem={(_) => <div>
                                            <div>
                                                <h3 className="mb-10">{_capitalize(_.charge.name)}</h3>
                                                <label>Charge - <span className="fw-b text-black">{_.charge.charge_json['charges']}</span></label>
                                                {/* <Statistic title="Charge" value={_.charge.charge_json['charges']}  valueStyle={{fontSize: 16}}/> */}
                                            </div>
                                            <Divider />
                                        </div>}
                                    />
                                </div>
                            </Panel>
                            <Panel
                                header={
                                    <div className="displayInline">
                                        <div>Pre-payment Charges - {this.props.prePaymentChargesList && this.props.prePaymentChargesList.get('data').size}</div>
                                    </div>
                                }
                                key="3" extra={this.props.schemeEditPermission ? (
                                    <Button onClick={this.togglePrePaymentChargeModal} type="link">Add New Pre Payment Charge</Button>
                                ) : null}>
                                <AntList
                                    border={false}
                                    className={"border-none"}
                                    footer={null}
                                    dataSource={this.props.prePaymentChargesList.get('data')}
                                    renderItem={this.renderPrePaymentCharges}
                                />

                            </Panel>
                        </Collapse>
                    </Card>
                    <ConfirmationActionModal
                        visible={this.state.confirmationModalShow}
                        modalTitle={"Caution!"}
                        onModalCancel={this.onModalCancel}
                        onModalConfirm={this.onModalConfirm}
                        modalBottomContent={`<div>Please be sure you are <b> NOT </b> migrating a <b> dummy scheme</b>. You can't undo this.<br>Are you sure, ${this.props.user.first_name}?</div>`} />
                </Col>
            </Row>
        );
    }
}


CompanySchemeDetailsDisplay.propTypes = {
    location: PropTypes.object,
    detail: PropTypes.object,
    history: PropTypes.object,
    companyId: PropTypes.string,
    fetchCompanyLosDetail: PropTypes.func,
    updateCompanyLosDetail: PropTypes.func,
    fetchCompanyLosErps: PropTypes.func,
    updateCompanyLosErps: PropTypes.func,
    fetchCompanyLosAnnualTurnovers: PropTypes.func,
    updateCompanyLosAnnualTurnovers: PropTypes.func,
    fetchCompanyLosBankingFacilities: PropTypes.func,
    updateCompanyLosBankingFacilities: PropTypes.func,
    fetchCompanyLosBrands: PropTypes.func,
    updateCompanyLosBrands: PropTypes.func,
    applicants: PropTypes.object,
    companyDetails: PropTypes.object,
    erpDetails: PropTypes.array,
    brandDetails: PropTypes.array,
    bankingDetails: PropTypes.array,
    annualTurnovers: PropTypes.array,
    updateCompanyLosSchemes: PropTypes.func,
    schemeDetails: PropTypes.array,
    fetchCompanyLosSchemes: PropTypes.func,
    schemeDetailsStatus: PropTypes.object,
    fetchFee: PropTypes.func,
    fetchFeeMaster: PropTypes.func,
    feeMaster: PropTypes.array,
    fetchAddFee: PropTypes.func,
    feeData: PropTypes.array,
    feeAddEditStatus: PropTypes.string,
    feeFetchStatus: PropTypes.string,
    schemeEditPermission: PropTypes.bool,
    user: PropTypes.object,
    schemeActionPermissions: PropTypes.bool
};

CompanySchemeDetailsDisplay.defaultProps = {
    schemeEditPermission: false
};

const mapStateToProps = (state, props) => ({
    schemeDetails: state.companyLosProfiles.getIn(["schemes", props.companyId, "data"], new List([])),
    schemeDetailsStatus: state.companyLosProfiles.getIn(["schemes", props.companyId, "status"], STATE_STATUS.UNFETCHED),
    feeMaster: state.companyLosProfiles.getIn(["feeMaster", "data"], []),
    feeData: state.companyLosProfiles.getIn(["fee", props.companyId, "data"], new List([])),
    feeAddEditStatus: state.companyLosProfiles.getIn(["feeAdd", props.companyId, "status"], STATE_STATUS.UNFETCHED),
    feeFetchStatus: state.companyLosProfiles.getIn(["fee", props.companyId, "status"], STATE_STATUS.UNFETCHED),
    schemeEditPermission: state.user.getIn(["permissions", "company_scheme_edit"]),
    schemeActionPermissions: state.user.getIn(["permissions", "page_company_scheme_edit"], false),
    // schemeActionPermissions : true,
    companyDetails: state.companyLosProfiles.getIn(["profiles", props.companyId, "data"], []),
    user: state.user.get("data"),
    roi_permissions: state.user.getIn(["permissions", "can_user_view_scheme_roi"], false),
    prePaymentChargesList: state.companyLosProfiles.get('prePaymentCharges', Map()),
    bounceChargesList: state.companyLosProfiles.get('bounceCharges' , Map()),

    prePaymentChargesListMaster: state.companyLosProfiles.get('prePaymentChargesMaster', Map()),
    bounceChargesListMaster: state.companyLosProfiles.get('bounceChargesMaster' , Map())

});

const mapDispatchToProps = dispatch =>
    bindActionCreators({
        fetchCompanyLosSchemes,
        updateCompanyLosSchemes,
        fetchFee,
        fetchFeeMaster,
        fetchAddFee,
        fetchBounceCharges,
        fetchPrePaymentCharges,
        fetchPrePaymentChargesMaster,
        fetchBounceChargesMaster
    },
        dispatch
    );


export default connect(mapStateToProps, mapDispatchToProps)(CompanySchemeDetailsDisplay);